/**
 * Chinese translations for documentation pages
 */

const zh: Record<string, string> = {
  // Common
  'common.backToHome': '返回首页',
  'common.backToDocs': '返回文档',
  'common.learnMore': '了解更多',
  'common.getStarted': '立即开始',
  'common.viewDocs': '查看文档',
  'common.signIn': '登录',
  'common.signUp': '注册',
  'common.dashboard': '控制台',
  'common.footer': '2025 Kizuna AI Lab. 保留所有权利。',
  'common.language': '语言',

  // Theme
  'theme.label': '主题',
  'theme.light': '浅色',
  'theme.dark': '深色',
  'theme.system': '跟随系统',

  // Navigation
  'nav.home': '首页',
  'nav.docs': '文档',
  'nav.scenarios': '使用场景',
  'nav.features': '功能',
  'nav.signIn': '登录',
  'nav.providers': '服务商',
  'nav.docsShort': '文档',
  'footer.tagline': '来自 Kizuna AI Lab。打破隔阂，建立连接。',
  'footer.trust': '免费开源 · 含端侧 AI · 无订阅',
  'footer.product': '产品',
  'footer.install': '安装',
  'footer.open': '开放',
  'footer.byok': '自带密钥',
  'footer.extension': '扩展',
  'footer.gettingStarted': '快速上手',
  'footer.meetingSites': '会议网站',
  'footer.providerSetup': '服务商配置',
  'footer.subtitleMode': '字幕模式',
  'nav.localAi': '本地 AI',
  'nav.download': '下载',
  'demo.me': '我',
  'demo.other': '对方',
  'demo.both': '两者',
  'demo.src': '原文',
  'demo.trans': '译文',
  'demo.subtitle': '字幕',
  'demo.exitSubtitle': '退出字幕模式',
  'demo.settings': '设置',
  'demo.channel.mic': '你的麦克风',
  'demo.channel.sys': '对方的声音',
  'demo.channel.out': 'Sokuji 说出的声音',
  'demo.endSession': '结束会话',
  'home.scenarios.title': '你想做什么？',
  'home.scenarios.lead': 'Sokuji 的设计前提是：跨越语言的成本，该由想被听懂的那个人来承担。我们最先做的就是这件事。但你并不总是那个人——有时你是在听讲座、在放一段录音，或者在别人开的会里。',
  'home.scenarios.featured': '我们最先做的就是这个',
  'home.scenarios.more': '每个预设具体设了什么',
  'home.install.title': '装应用，或者给浏览器加个扩展',
  'home.install.lead': '桌面应用不绑定支持网站清单。它在系统里注册成一个普通麦克风，所以凡是能选麦克风的软件都能用。',
  'home.install.desktop.title': '桌面应用 — 系统级',
  'home.install.desktop.body': 'Sokuji 在操作系统里就是一个普通麦克风。会议软件、浏览器、录音工具、直播软件、游戏——只要能选麦克风，就能听到你的译文语音。',
  'home.install.desktop.note': '反方向不需要任何人许可：Sokuji 读的是本机正在播放的声音，系统音也算，所以视频、直播、录音和通话一样能出字幕。',
  'home.install.routing.linux': '内置支持，基于 PulseAudio 或 PipeWire',
  'home.install.routing.macos': '驱动随应用一同安装',
  'home.install.routing.windows': '通过 VB-CABLE',
  'home.install.ext.title': '浏览器扩展',
  'home.install.ext.body': '系统里什么都不装，也不用配置音频路由。为它支持的会议网站专门做的。',
  'home.install.ext.note': '在这些页面里，你的译文语音以麦克风的形式交给网站，标签页自己的声音则被译回来。其他任何地方——别的应用、浏览器之外的视频、系统音——归桌面应用管。',
  'flow.youSpeak': '你说话',
  'flow.translates': 'sokuji 翻译',
  'flow.virtualMic': '虚拟麦克风',
  'flow.anyApp': '任意应用',
  'flow.theyHear': '对方听到',
  'flow.them': '对方',
  'flow.yourScreen': '你的屏幕',
  'flow.audience': '你的听众',
  'flow.onScreen': '屏幕上',
  'providers.page.title': '翻译究竟发生在哪里',
  'providers.page.lead': 'Sokuji 自己并不做识别和翻译——它采集你的声音，送到某处，再把回来的答案说进你的通话里。那个“某处”由你来选。一共三条路，你不会被锁在任何一条上。',
  'providers.routes.title': '三条路',
  'providers.local.chip': '免费 · 无需账号 · 离线',
  'providers.own.chip': '密钥在你手上 · 账单也归你',
  'providers.managed.chip': '按量计费 · 无订阅',
  'providers.table.title': '支持的服务商',
  'providers.table.lead': 'Sokuji 内置了这些适配器。“会说”指它能产出被说出来的翻译，而不只是文字——这正是招牌场景所需要的。凡是可以用 Kizuna AI 账号的行，都写明了真正跑模型的厂商，因为收到你音频的是他们。“面对面”指两个人共用一只麦克风，各自用一只耳机听对方的翻译；能做到这一点的服务商，也能分清对方那边的多位说话人。',
  'providers.col.provider': '服务商',
  'providers.col.runs': '怎么跑',
  'providers.col.speaks': '会说',
  'providers.col.faceToFace': '面对面',
  'providers.col.setup': '设置',
  'providers.speaks.yes': '会',
  'providers.speaks.textOnly': '只有文字',
  'providers.speaks.depends': '看情况',
  'providers.faceToFace.yes': '支持',
  'providers.faceToFace.no': '不支持',
  'providers.guide': '指南',
  'providers.run.local': '在你的机器上，按 GPU 下载对应引擎',
  'providers.run.direct': '你的密钥，直连 {vendor}',
  'providers.run.keyOrAccount': '你的密钥，或 Kizuna AI 账号 — 厂商：{vendor}',
  'providers.run.webrtc': '你的密钥，WebRTC 传输',
  'providers.cost.title': '这个账号要花多少钱',
  'providers.cost.lead': '只有这条路要花钱。Sokuji 本身免费且开源，端侧推理也随之免费。',
  'providers.cost.metered.title': '按量计费，从不按月',
  'providers.cost.metered.body': '你先充值，用多少扣多少。没用的月份不花钱，也没有席位数。',
  'providers.cost.metered.body2': '这里写不出一个统一价格，因为每家厂商的计量方式都不同——有的按音频时长，有的按模型处理量。真正适用的费率，会在你花钱之前显示在账号里那家厂商的旁边。',
  'providers.cost.path.title': '依然不在这条路径上',
  'providers.cost.path.body': '付钱给我们，并不会让我们挤到你和模型之间。我们只是把凭证交给你的设备，并数一数它花了多少；音频依旧从设备直达厂商，和你用自己密钥时完全一样。',
  'providers.cost.wired': '看看这是怎么接的',
  'providers.cost.note': '余额有效期一年。设这个期限，是因为没花掉的额度在我们账上是一笔负债，而不是为了催谁去花。',
  'providers.own.title': '你自己的 API 密钥',
  'providers.own.body': '在下面任一家服务商注册，把密钥粘进 Sokuji，然后直接付钱给那家服务商。每一家我们都写了带截图的操作步骤。没有任何东西经过我们。',
  'providers.managed.title': '通过 Kizuna AI 账号',
  'providers.managed.body': '给不想折腾开发者控制台的人。密钥由我们持有，账也由我们结；跑模型的仍然是 Soniox 或 Qwen。你的音频直接送到他们那里——我们不在这条路径上。',
  'providers.local.title': '在你自己的机器上',
  'providers.local.body': '下载与你 GPU 匹配的推理引擎，在本机完成识别与翻译。免费，断网可用，没有任何东西离开设备——包括发到我们这里。',
  'providers.price.title': '这里为什么不写价格',
  'providers.price.body': '每家厂商的计费方式都不一样——按分钟、按字符、按 token、按请求——同样一分钟的话，内容不同金额也不同。在这一页写死一个数字，对几乎每个看到它的人都是错的。适用于你的费率显示在你的账户里，按对应厂商分别列出。',
  'localai.page.title': '端侧不是备胎',
  'localai.page.lead': 'Sokuji 免费内置端侧的识别、翻译与语音合成。它不是为断网准备的——它是一等公民，我们认为它迟早会成为默认。',
  'localai.honest.lead': '与其吹嘘，不如把话说明白。',
  'localai.tomorrow.strong': '没有谁该为了用上 AI，就把自己的对话交给一家大型 AI 公司。',
  'localai.data.title': '每条路对你的数据意味着什么',
  'localai.data.lead': '三条路里，只有这一条的答案不需要任何补充说明。',
  'localai.col.ownKey': '自带密钥',
  'localai.col.account': 'Kizuna AI 账号',
  'localai.col.onDevice': '端侧',
  'localai.row.leaves': '音频离开你的机器',
  'localai.row.hear': '别人能听到',
  'localai.row.offline': '断网也能用',
  'localai.row.costs': '花多少钱',
  'localai.val.toVendor': '送到厂商',
  'localai.val.never': '从不',
  'localai.val.vendorCan': '厂商可以',
  'localai.val.nobody': '没有人',
  'localai.val.no': '否',
  'localai.val.yes': '是',
  'localai.val.vendorBills': '厂商向你收费',
  'localai.val.meteredByUs': '由我们计量',
  'localai.val.free': '免费',
  'localai.what.title': '在你机器上跑的是什么',
  'localai.chain.title': '识别、翻译、语音',
  'localai.chain.body': '整条链路都在本地跑：ASR 把你的声音变成文字，MT 翻译，TTS 说出来。没有一环需要网络。',
  'localai.engine.title': '与你硬件匹配的引擎',
  'localai.engine.body': 'Sokuji 会检测你的 GPU，下载为它构建的引擎包，并告诉你选了哪一个、有多大。',
  'localai.nokey.title': '没有密钥、没有账号、没有计量',
  'localai.nokey.body': '没有要注册的东西，也没有要花的钱。成本就只有你自己的硬件。',
  'localai.honest.title': '云端模型仍然更好，我们为什么还是内置它',
  'localai.today.title': '今天它处在哪里',
  'localai.today.body': '大型托管模型在准确度和延迟上仍然领先，重要的会你多半会选它。端侧的输出对相当多的对话已经够用——而且它是唯一一种除了你没有别人参与的配置。',
  'localai.tomorrow.title': '我们认为它会走向哪里',
  'localai.tomorrow.body': '模型在变小，运行时在变好，普通笔记本里的加速器也在变快。我们不认为这个差距会一直存在，也不打算等它消失了才把本地当成首选。',
  'privacyPage.hero.kicker': '隐私',
  'privacyPage.hero.title': '你的会议内容，只在你和你选的 AI 之间流动。',
  'privacyPage.hero.lead': '不管你怎么用 Sokuji，声音、屏幕画面、转写和译文都直接从你的设备发给你选择的 AI 服务商，不经过 Kizuna AI。区别只在于谁和 AI 服务商结算。',
  'privacyPage.hero.exception': '唯一的例外：用 Kizuna AI 账号克隆音色时，你录的声音样本会经过我们的服务器转交给 Soniox。我们不保存任何声音，转交完成即丢弃，服务器上只留 Soniox 返回的音色编号。',
  'privacyPage.hero.flowLabel': '会议内容从你的设备直接发给你选的 AI 服务商；使用 Kizuna AI 账号时，另有一条只承载账号、余额和用量的线连到 Kizuna AI。',
  'privacyPage.node.device': '你的设备',
  'privacyPage.node.provider': 'AI 服务商',
  'privacyPage.node.kizuna': 'Kizuna AI',
  'privacyPage.node.stays': '内容不离开本机',
  'privacyPage.way.ownKey.title': '用自己的密钥',
  'privacyPage.way.ownKey.body': '你直接和 AI 服务商结算，你的会话不经过我们的服务器。',
  'privacyPage.way.ownKey.note': 'Kizuna AI：不参与',
  'privacyPage.way.kizuna.title': '用 Kizuna AI 账号',
  'privacyPage.way.kizuna.body': '我们签发临时密钥、按用量计费；内容仍然直连 AI 服务商。',
  'privacyPage.way.kizuna.note': '虚线上只有：账号、余额与用量',
  'privacyPage.way.local.title': '在本机运行',
  'privacyPage.way.local.body': '使用端侧模型时，模型在你的电脑上运行，会议内容不会离开这台机器。',
  'privacyPage.way.local.note': '下载模型后可离线使用；在那之前，可能会自动使用微软的在线引擎（见下文）',
  'privacyPage.dest.title': '每一类数据去了哪里',
  'privacyPage.dest.lead': '完整清单。没有列在这里的会议内容，就不会离开你的设备。',
  'privacyPage.dest.contacts': '此外，Sokuji 还有几类不含会议内容的联网：下载端侧模型、检查更新，以及发送使用统计和错误报告。注意：本地推理里标着“在线”的引擎（Edge TTS 朗读、Bing 翻译）并不在你的电脑上运行；没有可用的端侧模型时会自动使用它们，你也可以手动选择，使用时要朗读或翻译的文字会发给微软。',
  'privacyPage.dest.provider.title': '你选的 AI 服务商',
  'privacyPage.dest.provider.who': '负责识别、翻译和朗读',
  'privacyPage.dest.provider.voices': '你和对方的声音',
  'privacyPage.dest.provider.screen': '屏幕画面（开启屏幕上下文时）',
  'privacyPage.dest.provider.text': '转写和译文',
  'privacyPage.dest.provider.voiceSample': '克隆音色用的声音样本',
  'privacyPage.dest.provider.foot': '按各服务商自己的隐私条款处理。',
  'privacyPage.dest.provider.link': '查看服务商列表',
  'privacyPage.dest.kizuna.title': 'Kizuna AI',
  'privacyPage.dest.kizuna.who': '只在你使用 Kizuna AI 账号时',
  'privacyPage.dest.kizuna.email': '邮箱和注册时填写的名字（可以是任意昵称）',
  'privacyPage.dest.kizuna.logins': '登录记录（IP 地址、设备、大致位置）',
  'privacyPage.dest.kizuna.billing': '余额、充值和每次的用量，以及用于验证付款的 Stripe 回传信息',
  'privacyPage.dest.kizuna.feedback': '你主动提交的反馈',
  'privacyPage.dest.kizuna.foot': '不含画面、转写或译文；声音也不含，唯一例外是转交给 Soniox 的克隆音色样本（见上文）。',
  'privacyPage.dest.device.title': '留在你这边',
  'privacyPage.dest.device.who': '任何模式下',
  'privacyPage.dest.device.history': '会话记录和导出文件',
  'privacyPage.dest.device.settings': '你的设置和自带密钥：桌面应用存在本机；手机应用把设置存在手机上；浏览器扩展在你开启 Chrome 同步时，会随你的 Google 账号同步',
  'privacyPage.dest.device.local': '只使用端侧模型时的全部会议内容',
  'privacyPage.dest.device.foot': '在应用里删除、清除浏览器数据、删除应用的数据文件夹，或卸载手机应用即可删除；导出的文件会留在你保存的位置。',
  'privacyPage.third.posthog.title': '使用统计 · PostHog',
  'privacyPage.third.posthog.body': '我们用 PostHog（美国）收集使用统计和错误报告，比如用了哪个服务商、会话时长、出错情况、设备和系统类型，以及在浏览器扩展中你打开扩展时所在页面的主机名，用来改进产品。登录后，这些统计会关联你的账号编号、邮箱和注册时填写的名字。不含任何会议内容。应用内目前没有关闭开关。',
  'privacyPage.third.stripe.title': '支付 · Stripe',
  'privacyPage.third.stripe.body': '充值由 Stripe 处理，完整卡号只交给 Stripe，我们拿不到。为了核对和验证付款，我们会收到 Stripe 回传的一些付款信息，比如付款人的姓名、邮箱和账单地址，以及卡的品牌和后四位。',
  'privacyPage.stored.title': '我们保存什么、保存多久',
  'privacyPage.stored.lead': '只有使用 Kizuna AI 账号时，以下数据才会存在我们的服务器上。',
  'privacyPage.stored.col.data': '数据',
  'privacyPage.stored.col.why': '为什么需要',
  'privacyPage.stored.col.keep': '保存多久',
  'privacyPage.stored.email.data': '邮箱和名字',
  'privacyPage.stored.email.why': '登录、验证账号、发放试用额度',
  'privacyPage.stored.email.keep': '账号存在期间',
  'privacyPage.stored.logins.data': '登录记录（IP 地址、设备、大致位置）',
  'privacyPage.stored.logins.why': '保持你的登录状态，并在排查账号问题时使用',
  'privacyPage.stored.logins.keep': '保存至账号删除为止',
  'privacyPage.stored.abuseIps.data': '防滥用 IP 记录',
  'privacyPage.stored.abuseIps.why': '防止同一个人重复领取试用额度',
  'privacyPage.stored.abuseIps.keep': '最后一次出现后 90 天',
  'privacyPage.stored.trial.data': '试用额度记录（邮箱的单向哈希；领取被拒时，还有匹配到的 IP 地址）',
  'privacyPage.stored.trial.why': '防止同一邮箱或同一个人重复领取试用额度',
  'privacyPage.stored.trial.keep': '长期保存，删除账号后也会保留',
  'privacyPage.stored.billing.data': '余额、充值和用量，以及用于验证付款的 Stripe 回传信息',
  'privacyPage.stored.billing.why': '计费、验证付款，并在账户页显示给你',
  'privacyPage.stored.billing.keep': '账号存在期间；删除账号后按适用的当地法律要求保存',
  'privacyPage.stored.feedback.data': '反馈内容',
  'privacyPage.stored.feedback.why': '回复你的问题',
  'privacyPage.stored.feedback.keep': '保存在我们的客服邮箱中',
  'privacyPage.stored.deletion': '你可以随时在账户页删除账号。删除后，邮箱、名字、登录记录、关联的登录方式和克隆的音色会被删除；防滥用 IP 记录按上表的期限自动删除；试用额度记录会保留，以免重复领取；计费记录（包括用于验证付款的 Stripe 回传信息）按法律要求保留。',
  'privacyPage.check.title': '不必只听我们说',
  'privacyPage.check.lead': 'Sokuji 是开源的（AGPL-3.0）。上面关于会议内容去向的说法，懂技术的人可以自己验证。',
  'privacyPage.check.code.title': '读代码',
  'privacyPage.check.code.body': '每一个会议内容的去向都写在 src/providers/、src/lib/edge-tts/ 和 src/lib/bing-translator/ 里，没有一个指向 Kizuna AI（克隆音色的样本除外，见上文）。',
  'privacyPage.check.network.title': '看网络请求',
  'privacyPage.check.network.body': '开一场会议，用浏览器开发者工具或代理抓包，会议内容的请求都直接发往 AI 服务商。',
  'privacyPage.check.offline.title': '断网运行',
  'privacyPage.check.offline.body': '只使用端侧模型时，模型下载好之后断开网络照样能用。',
  'privacyPage.promise.title': '我们的承诺',
  'privacyPage.promise.noSale': '不出售、不出租你的数据；除了上面列出的服务和正式隐私政策中列出的基础设施服务商，不与任何人共享。',
  'privacyPage.promise.noTraining': '不用你的数据训练模型，也不分析你的会议内容（我们本来就拿不到）。',
  'privacyPage.promise.trust': '账号服务器的代码不开源，这部分只能信我们。如果你不愿意，Sokuji 完全可以不登录使用：自带密钥，或在本机运行。',
  'privacyPage.end.note': '这是给普通用户的简明说明。具有法律效力的条款请看正式隐私政策。',
  'privacyPage.end.cta': '正式隐私政策',
  'download.page.title': '获取 Sokuji',
  'download.page.lead': '在 Windows、macOS 与 Linux 上都是免费开源的。每个平台在第一次运行前需要你做的事略有不同，这一页就是把它写清楚。',
  'download.desktop.title': '桌面端',
  'download.desktop.lead': '桌面应用会在系统里注册成一只麦克风，所以任何能选麦克风的程序都能用它。',
  'download.linux.note': '需要 pulseaudio-utils',
  'download.windows.note': 'VB-CABLE 需单独安装',
  'download.macos.note': '已签名并公证 · 阅读安装指南',
  'download.macos.noteLead': '已签名并公证 ·',
  'download.ext.addEdge': '添加到 Edge',
  'download.ext.addChrome': '添加到 Chrome',
  'download.macos.bodyBefore': '音频驱动包含在安装程序里，Apple 芯片与 Intel 都有。应用本身',
  'download.macos.signed': '已签名并通过 Apple 公证',
  'download.macos.bodyAfter': '，安装起来和其他 Mac 应用一样。',
  'download.need.linuxBefore': '运行中的 PulseAudio 或 PipeWire，外加',
  'download.need.linuxMid': '用于',
  'download.ext.title': '浏览器扩展',
  'download.ext.lead': '系统里什么都不用装，也不用安排音频路由。它是为会议网站做的，能把虚拟麦克风直接注入页面。',
  'download.ext.browser': 'Chrome 与 Edge',
  'download.ext.browserBody': 'Chromium 116 或更新版本，侧边栏 API。在商店里一键安装。',
  'download.ext.worksOn': '支持的网站',
  'download.ext.elsewhere': '其他情况请用桌面应用',
  'download.need.title': '安装之前',
  'download.need.col': '你需要什么',
  'download.need.linux': '运行中的 PulseAudio 或 PipeWire，外加提供 pactl 的 pulseaudio-utils',
  'download.need.windows': '用于音频路由的 VB-CABLE；安装程序会指给你',
  'download.need.macos': '随附的 SokujiVirtualAudio 驱动',
  'download.need.any': '任意平台',
  'download.need.anyBody': '一个服务商：端侧推理、你自己的 API 密钥，或者 Kizuna AI 账号。安装本身一个都不需要。',
  'download.need.nothing': '什么都不要',
  'download.need.nothingBody': '下载、安装，或者用自己的密钥、在本机使用 Sokuji，都不需要账号。',
  'download.linux.title': 'Linux',
  'download.linux.body': 'Debian 包或 AppImage，x64 与 arm64。虚拟麦克风由 Sokuji 自己通过 PulseAudio 或 PipeWire 创建——不用再装别的。',
  'download.windows.title': 'Windows',
  'download.windows.body': '已做代码签名，安装时不会出现常见的“发行者未知”警告——这要感谢免费为自由软件签名的 SignPath Foundation。音频走 VB-CABLE。',
  'download.macos.title': 'macOS',
  'download.macos.body': '音频驱动包含在安装程序里。应用本身已签名并通过 Apple 公证，安装起来和其他 Mac 应用一样。',
  'home.platform.linux.body': '虚拟麦克风由 Sokuji 自己通过 PulseAudio 或 PipeWire 创建——不用再装别的。',
  'home.platform.cta': '下载',
  'home.platform.windows.body': '已做代码签名，安装时不会弹出常见的警告——这要感谢免费为它签名的 SignPath Foundation。音频走 VB-CABLE。',
  'home.platform.macos.body': '音频驱动随安装程序一起提供。应用已签名并通过 Apple 公证，安装起来和其他 Mac 应用一样。',
  'home.faq.title': '为什么是这样设计的',
  'home.faq.lead': '我们收到的问题，大多其实是在问产品背后的取舍。这里直说。',
  'faq.audio.q': '你们会拿到我的音频或会议内容吗？',
  'faq.audio.a': '不会。音频、屏幕画面、转写和译文都从你的设备直接发往你选定的 AI 服务商。即使密钥来自 Kizuna AI 账号也一样：我们只负责签发临时密钥和计量用量，其余都由服务商完成。我们保存的是账号所需的信息（邮箱、登录记录、余额和用量），不含任何会议内容。完整清单见隐私说明页。',
  'faq.other.q': '为什么对方什么都不用装？',
  'faq.other.a': '因为我们认为，跨越语言是想被听懂的那个人的事，而不是所有听众的事。Sokuji 在你这一侧翻译，并通过虚拟麦克风说出来，所以传到对方那里的只是一段普通的通话音频。',
  'faq.service.q': '我必须用你们的 AI 服务吗？',
  'faq.service.a': '不必。你可以自带任一受支持服务商的密钥，也可以在本机免费运行。Kizuna AI 账号只是给不想折腾开发者控制台的人用的，不是为了把谁锁住。',
  'faq.cost.q': 'Sokuji 要多少钱？',
  'faq.cost.a': 'Sokuji 免费且开源，端侧推理也随之免费。唯一要花钱的是可选的 Kizuna AI 账号，按实际用量计费——从不是月度订阅，没用的月份就是零。充值余额有效期一年：这个期限是记账需要，不是催你花钱。自带密钥或在本机运行，你不会付给我们任何费用。',
  'faq.believe.q': '凭什么相信这一点？',
  'faq.believe.a': '有一半你不该相信——所以我们把界线画出来。应用采用 AGPL-3.0 许可，而决定音频去向的正是这个应用：全部代码在 github.com/kizuna-ai-lab/sokuji，你可以自己构建，也可以在网络层面亲自查看。我们的账号服务不开源，所以它如何处理账号和用量数据，是承诺，不是证明。这条线我们宁愿标出来，也不愿把它抹糊。',
  'faq.youtube.q': '能用它实时翻译 YouTube 吗？',
  'faq.youtube.a': '可以，也没什么拦着你——Sokuji 会翻译任何传到你机器上的声音，视频也一样。只是我们不为这个场景而做。一个十万人看的视频，每人各自实时翻译一遍，等于同一件事做了十万次；由发布者翻译一次，就只做一次。创作者确实会用 Sokuji 来做这份翻译。',
  'faq.local.q': '本地 AI 只是断网时的备胎吗？',
  'faq.local.a': '不是。它一开始就是一等公民，而且一直免费。模型在变小，运行时在变好，消费级加速器在变快。没有谁该为了用上 AI，就把自己的对话交给一家大型 AI 公司。',
  'faq.platforms.q': 'Sokuji 在 macOS 和 Windows 上有签名吗？',
  'faq.platforms.a': '有。Windows 安装程序由 SignPath Foundation 免费签名。macOS 版从 0.46.5 起使用 Apple Developer ID 签名，并通过 Apple 公证。',
  'home.during.title': '通话过程中它在做什么',
  'home.during.lead': '把语音丢给模型谁都会。难的是让它在整场会议里一直可听懂——跟得上节奏、判断你话说完了没有、不把你自己的声音又送回去——这是音频工程。',
  'feat.voice.t': '用你自己的声音',
  'feat.voice.b': '录一段短音频，译出的语音就带着你的声音而不是通用音色，也可以从提供商的音色库里挑。能选哪些音色取决于你在用哪家。',
  'feat.tempo.t': '语速自适应',
  'feat.tempo.b': '同一句话在不同语言里长度不同，固定语速下译文会一句比一句落后。Sokuji 只把语速提到刚好跟上的程度。',
  'feat.turn.t': '按语义断句',
  'feat.turn.b': '它等的是一个完整的意思，而不只是一次停顿——所以你不会被从句子中间切断。',
  'feat.terms.t': '你的说法，你的术语',
  'feat.terms.b': '系统指令会保住人名、产品名和内部行话，不让它们被译成一团糊。',
  'feat.overlay.t': '字幕浮层',
  'feat.overlay.b': '可以是一个能拖动、能缩放的独立窗口，也可以是盖在会议页面上的字幕。',
  'feat.offline.t': '断网也能用',
  'feat.offline.b': 'Sokuji 检测你的 GPU，下载为它构建的推理引擎，在你自己的机器上完成识别、翻译和合成——无密钥、无账号、无计量。 在这里，端侧是一等公民，而不是断网时的备胎。',
  'home.during.also': '此外还有：按住即译、降噪、回声消除、部分转写即时翻译、音频缓冲调节、会话进行中切换音频设备、虚拟麦克风本身，以及把对话导出为 .txt 或 .json。',
  'home.carry.title': '我们替你扛的，和留在你手里的',
  'home.carry.lead': 'Sokuji 免费、开源，并且会一直如此。另一件相互独立的事是：Kizuna AI 账号可以替你保管几家 AI 厂商的密钥并结算账单——给不想折腾开发者控制台的人用。模型不是我们跑的，而且这项服务你可能一次都用不上。每一处便利旁边，都留着出口。',
  'carry.ours': '这些由我们扛',
  'carry.yours': '这些你随时可以自己来',
  'carry.account.t': '一个账号，不碰控制台',
  'carry.account.b': '我们发放凭证并结算账单。跑模型的仍然是 Soniox 或 Qwen。',
  'carry.bill.t': '一份账单，按量计费',
  'carry.bill.b': '支付那套管道由我们接手，按你实际用掉的量收费。',
  'carry.cloud.t': '需要时用云端模型',
  'carry.cloud.b': '当下最快、最准的翻译，需要时才用。',
  'carry.packaged.t': '打包好的应用',
  'carry.packaged.b': '桌面版和浏览器扩展，几次点击就装好。',
  'carry.ownkey.t': '用你自己的密钥',
  'carry.ownkey.b': '支持十余家提供商，每家都有配图的操作步骤。',
  'carry.direct.t': '直接付给提供商',
  'carry.direct.b': '完全把我们排除在外。没有 Kizuna AI 账号，Sokuji 照样能用。',
  'carry.machine.t': '在自己的机器上跑',
  'carry.machine.b': '本地推理，免费，可离线，并且是作为首选内置的。',
  'carry.source.t': '从源码构建',
  'carry.source.b': '克隆、阅读、修改、发布你自己的构建版本。AGPL-3.0。',
  'stat.langs': '可翻译语言',
  'stat.ui': '界面语言',
  'stat.sites': '扩展支持的会议网站',
  'stat.providers': 'AI 服务商，也可指向自建端点',
  'home.platforms.title': '每个平台，以及各自需要你做什么',
  'download.builds': '安装包',
  'download.readGuide': '阅读安装指南',
  'home.install.flowLabel': '你的声音经翻译、通过虚拟麦克风到达对方',
  'home.routing.title': '你的会议内容不经过我们',
  'home.routing.lead': '即使密钥来自你的 Kizuna AI 账号，音频、屏幕画面和译文也是从你的设备直接去运行模型的厂商；如果你选的是本地模型，它们根本不出这台机器。我们只负责账号和计费，保存的是账号和用量相关的数据，不含任何会议内容。',
  'routing.you': '你',
  'routing.sokuji': 'sokuji（在你的设备上）',
  'routing.provider': '你选的 AI 提供商',
  'routing.providerNote': '云端，或你自己的机器',
  'routing.up': '你的音频（上行）',
  'routing.down': '译文（回来）',
  'routing.onDevice': '本地模型：两段都不出这台机器',
  'routing.mic': '虚拟麦克风',
  'routing.app': '任意应用',
  'routing.them': '对方',
  'routing.kizuna': 'Kizuna AI',
  'routing.kizunaCarries': '临时密钥 · 用量计费 · 无会议内容',
  'routing.label': '会议内容在你的设备和你选的提供商之间往返，Kizuna AI 在一条只承载密钥、账号和用量的旁支上',
  'routing.or': '或',
  'scenarios.page.title': '你想做什么？',
  'scenarios.page.lead': '这些是预设，不是把你锁住的模式——它们设的每一项后面都能改。',
  'scenarios.axes.title': '每一个预设决定了什么',
  'scenarios.axes.lead': '五个预设其实是同样三个决定的不同答案：翻译谁的声音、结果是否念出来、以及屏幕上最后留下什么。',
  'axis.sets': '它决定什么',
  'scenarios.whoPicks': '谁会选它：',
  'scenarios.anyApp.lead': '“任意应用”是字面意思。',
  'scenarios.anyApp.body': '出去的那一侧，Sokuji 就是一只普通麦克风，所以任何能选麦克风的东西都能带上你被翻译过的声音——浏览器标签页、录音软件、直播软件、游戏。进来的那一侧，它处理你机器上正在播放的一切，包括系统声音，所以视频、直播、录像的行为和通话完全一样。',
  'scenarios.fit.title': '并不是每家服务商都能做每一种场景',
  'scenarios.fit.lead': '关键在两点。第一点是这家服务商能不能出声，以及能不能让它闭嘴：只返回文字的，没法把你这边说进通话里；一律用语音作答的，没法只留字幕。Sokuji 目前提供的服务商两样都行，但这项检查会为以后的服务商留着。第二点是面对面：两个人共用一只麦克风，需要服务商分得清是谁在说，目前只有 Soniox 做得到——用你自己的密钥，或通过 KizunaAI。Sokuji 在你选服务商时就检查这两点，所以做不到的场景会在通话之前被关掉，而不是在通话当中被发现。',
  'scenarios.fit.available': '可用',
  'scenarios.fit.unavailable': '该服务商不支持',
  'scenarios.fit.note': '“听懂对方”是唯一到处都能用的：它从文字开始，只有你打开「我听到的翻译」时才会把对方念出来。最后一列是 Soniox——用你自己的密钥，或通过 KizunaAI。',
  'provider.textOnly': '只返回\n文字',
  'provider.alwaysSpeaks': '一律\n出声',
  'provider.either': '两者\n都行',
  'provider.faceToFace': '两者都行\n能面对面',
  'spoken.yesVoice': '是 — 用合成语音送进通话',
  'spoken.yesBoth': '是 — 你这一侧送进通话，对方那一侧念给你',
  'spoken.yesEarbuds': '是 — 你们各用一只耳机听对方',
  'spoken.optional': '否 — 除非你打开「我听到的翻译」',
  'flow.you': '你',
  'flow.subtitles': '字幕',
  'flow.anyAppSystem': '任意应用\n或系统声音',
  'flow.yourHeadphones': '你的耳机',
  'flow.yourEarbud': '你那只耳机',
  'flow.theirEarbud': '对方那只耳机',
  'flow.sameScreen': '同一块屏幕',
  'scenario.understand-others.who': '你是听的一方，而说话的人不会为你迁就。',
  'scenario.be-heard.who': '在一屋子人不共用的语言里说话的人——而且这个会未必是你开的。',
  'scenario.subtitle-myself.who': '演讲者与主播——在自己的声音上再叠一层声音，不如直接上字幕。',
  'scenario.two-way-voice.who': '双方都没有共同语言的一场真正的来回对话。',
  'scenario.two-way-text.who': '会被录下来的会议、要做纪要的场合，或者任何多一层声音就不受欢迎的房间。',
  'scenario.face-to-face-voice.who': '同处一室、却没有共同语言的两个人——在办公桌、柜台或餐桌旁。',
  'scenario.face-to-face-text.who': '同一个房间里，不想耳边多一个声音，或者对方更愿意在自己的手机上读。',
  'axis.whoseAudio': '翻译哪一侧',
  'axis.spokenAloud': '是否念出',
  'axis.onScreen': '屏幕上显示',
  'audio.speaker': '你的麦克风',
  'audio.participant': '对方',
  'audio.both': '双方',
  'audio.besideMe': '你们两人，共用一只麦克风',
  'spoken.yes': '是',
  'spoken.no': '否',
  'scenario.understand-others.onScreen': '对方发言的译文',
  'scenario.understand-others.flow': '对方说 → 你读',
  'scenario.be-heard.onScreen': '你的原话和译文并排',
  'scenario.be-heard.flow': '你说 → 对方听',
  'scenario.subtitle-myself.onScreen': '译文，给你的听众看',
  'scenario.subtitle-myself.flow': '你说 → 对方读',
  'scenario.two-way-voice.onScreen': '原文和译文，双方都有',
  'scenario.two-way-voice.flow': '双向 · 两边都有语音',
  'scenario.two-way-text.onScreen': '原文和译文，双方都有',
  'scenario.two-way-text.flow': '双向 · 只有文字',
  'scenario.face-to-face-voice.onScreen': '双方都有，每一行标出它在哪只耳朵播放',
  'scenario.face-to-face-voice.flow': '一只麦克风 · 每人一只耳机',
  'scenario.face-to-face-text.onScreen': '原文和译文，双方都有',
  'scenario.face-to-face-text.flow': '一只麦克风 · 只有文字',
  'scenario.understand-others.title': '听懂对方',
  'scenario.understand-others.body': '在线会议、网课、讲座、视频、直播——实时阅读你听到内容的翻译。',
  'scenario.understand-others.detail': '在线会议、网课、讲座、视频、直播——实时阅读你听到内容的翻译。除非你打开「我听到的翻译」，否则不会念出声。',
  'scenario.be-heard.title': '让对方在会议里听懂我',
  'scenario.be-heard.body': '对方通过虚拟麦克风听到你翻译后的语音。',
  'scenario.be-heard.detail': '对方通过虚拟麦克风听到你翻译后的语音。对方不用装软件、不用插件，也不用读字幕。',
  'scenario.subtitle-myself.title': '给我的发言配字幕',
  'scenario.subtitle-myself.body': '演讲、直播、演示——观众阅读翻译字幕，不生成语音。',
  'scenario.subtitle-myself.detail': '演讲、直播、演示——观众阅读翻译字幕，不生成语音。你照常用自己的声音说话。',
  'scenario.two-way-voice.title': '在线双向对话',
  'scenario.two-way-voice.body': '对方听到你的翻译语音；你看到对方的字幕，也可以听到译音。',
  'scenario.two-way-voice.detail': '对方听到你的翻译语音；你看到对方的字幕，也可以听到译音。在桌面版中，只有当「对方音频」是某一个应用（例如你的会议软件）时，对方的翻译才会念给你听；捕获整个系统的声音时你只能读字幕。',
  'scenario.two-way-text.title': '在线双向对话，只要字幕',
  'scenario.two-way-text.body': '双语字幕、会议记录——双方都以文字呈现，不使用合成语音。',
  'scenario.two-way-text.detail': '双语字幕、会议记录——双方都以文字呈现，不使用合成语音。',
  'scenario.face-to-face-voice.title': '面对面对话',
  'scenario.face-to-face-voice.body': '两个人在同一台电脑前，各说各的语言；每人戴一只耳机，只听到翻译成自己语言的内容。',
  'scenario.face-to-face-voice.detail': '两个人在同一台电脑前，各说各的语言；每人戴一只耳机，只听到翻译成自己语言的内容。默认你那只耳机是左声道，对方那只是右声道。',
  'scenario.face-to-face-text.title': '面对面对话，只要字幕',
  'scenario.face-to-face-text.body': '两人看同一块屏幕，或者对方在手机上打开 LAN 字幕页面。',
  'scenario.face-to-face-text.detail': '两人看同一块屏幕，或者对方在手机上打开 LAN 字幕页面。LAN 字幕页面只在桌面版中提供。',
  'nav.install': '安装',
  'nav.platforms': '平台',
  'nav.platformsOverview': '概述',
  'nav.aiProviders': 'AI 提供商',
  'nav.kizunaAI': 'KizunaAI',
  'nav.kizunaAIFeatures': 'KizunaAI 功能',
  'nav.providersOverview': '概述',
  'nav.privacy': '隐私政策',
  'nav.terms': '服务条款',
  'footer.terms': '条款',
  'nav.commerce': '商业信息披露',
  'nav.feedback': '反馈',
  'nav.github': 'GitHub',

  // Tutorials
  'tutorials.zoom': 'Zoom',
  'tutorials.googleMeet': 'Google Meet',
  'tutorials.teams': 'Microsoft Teams',
  'tutorials.discord': 'Discord',
  'tutorials.slack': 'Slack',
  'tutorials.jitsi': 'Jitsi Meet',
  'tutorials.whereby': 'Whereby',
  'tutorials.gather': 'Gather',
  'tutorials.openai': 'OpenAI 设置',
  'tutorials.gemini': 'Gemini 设置',
  'tutorials.palabraai': 'PalabraAI 设置',
  'tutorials.volcengineAST2': '豆包同声传译 2.0 设置',
  'tutorials.soniox': 'Soniox 设置',
  'tutorials.qwen': 'Qwen LiveTranslate 设置',
  'tutorials.kizunaQuickStart': '快速入门',
  'tutorials.twoWayMeeting': '双向会议翻译',
  'tutorials.understandOthers': '听懂会议与视频',
  'tutorials.beUnderstood': '在会议中发言',
  'tutorials.subtitleMySpeech': '为演讲配字幕',
  'tutorials.twoWaySubtitles': '双向字幕',
  'tutorials.faceToFace': '面对面对话',
  'tutorials.kizunaVoices': '声音与声音克隆',
  'tutorials.kizunaVocabulary': '自定义词表',
  'tutorials.kizunaRegion': '处理区域',
  'tutorials.kizunaLatency': '断句与延迟',
  'tutorials.kizunaBilling': '余额与费用',
  'tutorials.localInference': '免费（本机运行）设置',
  'tutorials.localModels': '本地模型与许可证',
  'tutorials.realtimeTester': 'API 测试器',

  // Landing Page
  'landing.title': 'Sokuji',
  'landing.slogan.line1': '用自己的语言说。',
  'landing.slogan.line2': '以对方的语言被听懂。',
  'landing.tagline': 'AI 驱动的实时语音翻译',
  'landing.subtitle': '你的声音以对方的语言传出去，对方说的话以你的语言回来——作为字幕，或者念给你听。Sokuji 是你与会议软件之间的一只虚拟麦克风，所以要设置的只有你这一边——对方照常说话，不用装任何东西，也不用点任何链接。',
  'landing.trust': '免费开源 · 端侧 AI · 无订阅',
  'landing.cta.extension': '获取浏览器扩展',
  'landing.cta.desktop': '免费下载',
  'landing.cta.docs': '查看文档',

  // Platform Selection
  'platform.title': '选择您的平台',
  'platform.extension.title': '浏览器扩展',
  'platform.extension.desc': '适用于在线会议（Google Meet、Zoom、Teams 等）',
  'platform.extension.chrome': 'Chrome 网上应用店',
  'platform.extension.edge': 'Edge 加载项',
  'platform.extension.brave': 'Brave（即将推出）',
  'platform.desktop.title': '桌面应用程序',
  'platform.desktop.desc': '适用于所有场景 - 任何网站、应用或系统音频',
  'platform.desktop.windows': 'Windows 安装程序 (.exe)',
  'platform.desktop.macos.arm': 'macOS 安装程序 - Apple Silicon (-arm64.pkg)',
  'platform.desktop.macos.intel': 'macOS 安装程序 - Intel (-x64.pkg)',
  'platform.desktop.linux': 'Linux 软件包 (.deb)',

  // Installation Guides
  'install.title': '安装指南',
  'install.windows': 'Windows 安装指南',
  'install.macos': 'macOS 安装指南',
  'install.linux': 'Linux 安装指南',

  // Docs Home
  'docs.title': '文档',
  'docs.subtitle': '了解如何安装和使用 Sokuji',
  'docs.gettingStarted': '快速开始',
  'docs.installation': '安装',
  'docs.configuration': '配置',
  'docs.resources': '资源',
  'docs.card.participantAudio': '翻译对方说的话：来自会议应用、浏览器标签页或整个系统的声音。',
  'docs.card.subtitleMode': '一个细长的浮动字幕条，可以放在会议、视频或幻灯片上方。',

  // Supported Sites
  'sites.title': '支持的网站',
  'sites.subtitle': 'Sokuji 扩展兼容以下视频会议和通信平台。',
  'sites.howToUse.title': '如何使用',
  'sites.howToUse.desc': '在任何支持的平台上，只需在平台的音频设置中选择"Sokuji Virtual Microphone"作为麦克风输入。Sokuji 将为您的语音提供实时翻译。',
  'sites.needHelp.title': '需要帮助？',
  'sites.needHelp.desc': '如果您在特定平台上遇到问题，请查看我们的 GitHub 仓库获取故障排除指南和支持。',
  'sites.visitPlatform': '访问平台',
  'sites.tutorial': '教程',

  // Site Cards
  'sites.meet.name': 'Google Meet',
  'sites.meet.url': 'meet.google.com',
  'sites.meet.features': '',

  'sites.teams.name': 'Microsoft Teams',
  'sites.teams.url': 'teams.live.com / teams.microsoft.com',
  'sites.teams.features': '跨平台兼容|个人版和企业版',

  'sites.gather.name': 'Gather',
  'sites.gather.url': 'app.gather.town',
  'sites.gather.features': '空间音频支持',

  'sites.whereby.name': 'Whereby',
  'sites.whereby.url': 'whereby.com',
  'sites.whereby.features': '基于浏览器的会议',

  'sites.discord.name': 'Discord',
  'sites.discord.url': 'discord.com',
  'sites.discord.features': '语音频道支持',

  'sites.slack.name': 'Slack',
  'sites.slack.url': 'app.slack.com',
  'sites.slack.features': 'Huddles 和通话支持',

  'sites.jitsi.name': 'Jitsi Meet',
  'sites.jitsi.url': 'meet.jit.si',
  'sites.jitsi.features': '开源会议支持',

  'sites.zoom.name': 'Zoom',
  'sites.zoom.url': 'app.zoom.us',
  'sites.zoom.features': '网页客户端支持',

  // AI Providers
  'providers.title': '支持的 AI 提供商',
  'providers.subtitle': 'Sokuji 支持多个 AI 提供商进行实时语音翻译。每个提供商提供不同的功能、模型和定价结构。免费模式无需 API 密钥，在您的设备上免费运行；只有部分语音需要联网。',
  'providers.setup.title': '设置说明',
  'providers.setup.desc': '要使用云端 AI 提供商，请从提供商网站获取 API 密钥，并在 Sokuji 设置面板中配置。免费模式无需 API 密钥 — 只需下载模型即可开始翻译。',
  'providers.choosing.title': '选择提供商',
  'providers.needHelp.title': '需要帮助？',
  'providers.needHelp.desc': '有关设置指南、故障排除和提供商比较，请访问我们的 GitHub 仓库。',
  'providers.docs': '文档',
  'providers.setupTutorial': '设置教程',

  // Provider Cards
  'providers.openai.name': 'OpenAI',
  'providers.openai.type': '实时音频 API',
  'providers.openai.features': 'GPT-4o 实时预览模型|8 种优质语音选项|高级轮次检测模式|内置降噪|支持 60+ 种语言|自定义提示模板模式',
  'providers.openai.desc': '最适合高质量语音合成和高级功能',

  'providers.gemini.name': 'Google Gemini',
  'providers.gemini.type': 'Gemini Live API',
  'providers.gemini.features': 'Gemini 2.0 Flash Live 模型|30 种独特语音个性|自动轮次检测|35+ 种语言及地区变体|内置转录|高 token 限制 (8192)',
  'providers.gemini.desc': '非常适合多语言支持和自动处理',

  'providers.palabra.name': 'PalabraAI',
  'providers.palabra.type': 'WebRTC 翻译服务',
  'providers.palabra.features': '实时 WebRTC 翻译|60+ 种源语言|40+ 种目标语言|低延迟流式传输|自动音频处理|专为实时翻译优化',
  'providers.palabra.desc': '针对最小延迟的实时翻译优化',



  'providers.volcengineAST2.name': '豆包同声传译 2.0',
  'providers.volcengineAST2.type': '语音到语音翻译',
  'providers.volcengineAST2.features': '端到端语音到语音翻译|声音复刻，或从 500 多个固定音色中挑选|低延迟同声传译|20 种语言加粤语、吴语，其中 8 种可朗读|应用 ID + 访问令牌，或 API 密钥|字节跳动云基础设施',
  'providers.volcengineAST2.desc': '豆包语音到语音同声传译服务，可复刻说话者的声音，也可挑选固定音色',
  'providers.soniox.name': 'Soniox',
  'providers.soniox.type': '语音到语音翻译',
  'providers.soniox.features': '实时语音到语音翻译|在单个 API 调用中转写并翻译 60+ 种语言|自动语言检测|200 个内置声音与声音克隆|朗读翻译或仅字幕|面对面对话与说话人标注|Soniox 云基础设施',
  'providers.soniox.desc': 'Soniox 实时语音到语音翻译，覆盖 60 多种语言，支持自动语言检测',

  'providers.qwen.name': 'Qwen LiveTranslate',
  'providers.qwen.type': '语音到语音同声传译',
  'providers.qwen.features': '一个流式会话完成实时同声传译（qwen3.8-livetranslate-flash-realtime）|60 种语言，其中 29 种可朗读，源语言自动识别|47 个预设声音，或实时复刻您自己的声音、无需录音|名称和术语的指定译法|朗读翻译或仅显示字幕|您自己的密钥来自 QwenCloud（国际版）或千问云（中国内地），或使用 Kizuna AI 账号|阿里云基础设施；桌面应用和浏览器扩展',
  'providers.qwen.desc': '能用您自己的声音（实时复刻）朗读译文的同声传译，覆盖 60 种语言',

  'providers.localInference.name': '免费',
  'providers.localInference.type': '设备端 AI（边缘计算）',
  'providers.localInference.features': '完全离线 — 无需 API 密钥或互联网|40+ 个 ASR 模型覆盖 99+ 种语言|55+ 翻译语言对 + Qwen LLM|136 个 TTS 模型覆盖 53 种语言|CPU (WASM) 和 WebGPU 加速|隐私优先 — 所有数据保留在设备上',
  'providers.localInference.desc': '完全在您的设备上运行，数据不离开您的设备 — 非常适合对隐私敏感的使用场景',

  // Privacy Policy
  'privacy.title': '隐私政策',
  'privacy.lastUpdated': '最后更新：2026 年 11 月 3 日',
  'privacy.intro.title': '引言',
  'privacy.intro.content': '本隐私政策说明 Kizuna AI Lab（以下简称“我们”）在您使用 Sokuji（包括桌面应用、手机应用、浏览器扩展、sokuji.kizuna.ai 网站及 Kizuna AI 账户，以下统称“本服务”）时，如何收集、使用、披露、保存和保护相关信息。',
  'privacy.guarantee.title': '会议内容',
  'privacy.guarantee.content': '会议内容（音频、您为屏幕上下文所选窗口、标签页或屏幕的画面、转写及译文）由您的设备直接发送至您所选择的 AI 服务商。除“会议内容的传输”一节所述的声音样本例外情形外，我们不在服务器上接收、处理或保存会议内容。具体而言，我们不保存：',
  'privacy.guarantee.items': '音频录音或其他声音内容|为屏幕上下文发送的屏幕画面|转写、译文或其他对话内容',
  'privacy.collect.title': '我们收集的信息',
  'privacy.collect.content': '“账户信息”“登录记录”“防滥用记录”及“计费、用量与支付信息”各节所述信息，仅在您创建或使用 Kizuna AI 账户时收集。使用统计和错误报告则无论您是否登录，均从桌面应用、手机应用、浏览器扩展及网站收集。',
  'privacy.account.title': '账户信息',
  'privacy.account.content': '如您创建 Kizuna AI 账户，我们收集以下信息：',
  'privacy.account.items': '电子邮箱：用于注册、登录、账户验证、找回密码及发放试用额度。|密码：仅以加盐的 scrypt 哈希形式保存，我们不会保存或获取您的明文密码。|显示名称：您注册时填写的名称，可以是任意昵称。|账户创建日期，以及用于保持您登录状态的会话令牌。',
  'privacy.signin.title': '登录记录',
  'privacy.signin.content': '您每次登录时，我们记录 IP 地址、用户代理（浏览器及设备类型），以及根据 IP 地址推断的大致位置（国家、地区、城市及大致坐标）。我们使用该等记录以保持您的登录状态、保障账户安全及排查账户问题。',
  'privacy.abuse.title': '防滥用记录',
  'privacy.abuse.content': '为防止同一人重复领取试用额度，我们记录与账户活动相关的 IP 地址。我们还保存试用额度记录：获得试用额度的电子邮箱的单向哈希值，以及（领取被拒时）匹配到的 IP 地址。',
  'privacy.billing.title': '计费、用量与支付信息',
  'privacy.billing.content': '我们记录您的余额、充值及每次会话的用量（如时长、服务商和区域），用于向您计费并向您展示用量。支付由 Stripe 处理；您的完整卡号仅提供给 Stripe，我们不会获取。为核对和验证付款，我们会从 Stripe 收到部分付款信息，例如付款人姓名、电子邮箱和账单地址，以及银行卡的品牌和后四位。',
  'privacy.collect.analytics.title': '使用统计与错误报告',
  'privacy.collect.analytics.content': '我们使用位于美国的 PostHog 收集使用统计和错误报告，包括：',
  'privacy.collect.analytics.items': '所用功能、所选 AI 服务商及会话时长|错误、错误报告及性能数据|设备、操作系统及浏览器类型|语言选择|在浏览器扩展中，您打开扩展时所在页面的网址（主机名）',
  'privacy.collect.analytics.identity': '您登录后，上述信息会与您的账户 ID、电子邮箱及显示名称相关联。上述信息不包含会议内容。本服务目前未提供在应用内关闭统计的设置；您可按“您的权利”一节所述申请删除您的统计数据。',
  'privacy.feedback.title': '反馈与通信',
  'privacy.feedback.content': '如您提交反馈或与我们联系，我们会收到您的消息内容、电子邮箱及随附的技术信息，例如浏览器的用户代理、应用版本和设备型号，以及（如您已登录）您的账户 ID。',
  'privacy.localOnly.title': '保存在您设备上的信息',
  'privacy.localOnly.content': '以下信息保存在您的设备上，不会传输至我们的服务器：',
  'privacy.localOnly.items': '设置及您自己的 API 密钥：桌面应用将其保存在您的电脑本地。手机应用将设置保存在您的手机上。浏览器扩展将其保存在浏览器的扩展存储中；如您开启 Chrome 同步，浏览器会依照 Google 的隐私条款通过您的 Google 账号同步这些数据。|会话记录及导出文件。|仅使用端侧模型时的全部会议内容。',
  'privacy.storage.transmission.title': '会议内容的传输',
  'privacy.storage.transmission.content': '会议内容通过加密连接，由您的设备直接传输至您所选择的 AI 服务商。使用 Kizuna AI 账户时，我们为该服务商签发短时有效的凭证并计量您的用量，但内容本身不经过我们的服务器。手机应用通过 Kizuna AI 账户使用 Soniox，在首次发送语音之前会征求您的同意；您可以在“设置 > 关于”中撤回。本地推理中标有“在线”的引擎（Edge TTS 和 Bing 翻译）并非端侧模型：没有可用的端侧模型时会自动使用它们，您也可以手动选用；使用时，要朗读或翻译的文字会发送至微软。例外情形：您使用 Kizuna AI 账户创建克隆音色时，您录制的声音样本会经由我们的服务器传输至 Soniox 以创建该音色。我们不保存该声音样本，仅保留 Soniox 返回的音色标识；您删除该音色或账户时，该标识随之删除。',
  'privacy.use.title': '我们如何使用信息',
  'privacy.use.items': '提供、运营和维护本服务及您的账户|签发服务商凭证、计量用量并向您计费|验证付款|防止滥用试用额度|保障账户安全并排查问题|了解本服务的使用情况并加以改进|回复您的反馈和请求|履行法律义务',
  'privacy.thirdParty.title': '第三方服务',
  'privacy.thirdParty.content': '以下第三方会因本服务而收到相关信息，并各自依照其隐私条款处理。',
  'privacy.thirdParty.cloudflare.title': 'Cloudflare',
  'privacy.thirdParty.cloudflare.content': '我们使用 Cloudflare 提供网站托管、内容分发、账户与计费数据库（Cloudflare D1）及事务性邮件服务。',
  'privacy.thirdParty.zoho.title': 'Zoho',
  'privacy.thirdParty.zoho.content': '我们的电子邮箱（包括 support@kizuna.ai、privacy@kizuna.ai 和 contact@kizuna.ai）由 Zoho 托管。您发送给我们的反馈和邮件依照 Zoho 的隐私条款保存在上述邮箱中。',
  'privacy.thirdParty.stripe.title': 'Stripe',
  'privacy.thirdParty.stripe.content': 'Stripe 处理充值付款。Stripe 依照其隐私政策接收您的支付信息，并向我们提供“计费、用量与支付信息”一节所述的付款信息。',
  'privacy.thirdParty.posthog.title': 'PostHog',
  'privacy.thirdParty.posthog.content': '位于美国的 PostHog 接收“使用统计与错误报告”一节所述的使用统计和错误报告。',
  'privacy.thirdParty.soniox.title': 'Soniox',
  'privacy.thirdParty.soniox.content': '使用 Soniox 时（无论用您自己的 API 密钥还是通过 Kizuna AI 账户），音频以及（用于语音输出时）要朗读的文字会发送到您所选区域（美国、欧盟或日本）的 Soniox 服务器，按 Soniox 的隐私政策处理。',
  'privacy.thirdParty.alibaba.title': '阿里云（Qwen）',
  'privacy.thirdParty.alibaba.content': '使用 Qwen LiveTranslate 时，音频，以及开启屏幕上下文时您所选的那一个窗口、标签页或屏幕的画面，会发送到阿里云的 Qwen 服务。使用您自己的 API 密钥时，数据发往该密钥创建时所在的区域——新加坡或北京（中国内地），由密钥决定——并按签发该密钥的服务（QwenCloud 或千问云）的条款处理。通过 Kizuna AI 账号使用时，数据发往您在 Sokuji 中选择的区域（新加坡或北京），并按阿里云的隐私政策处理。',
  'privacy.thirdParty.openai.title': 'OpenAI',
  'privacy.thirdParty.openai.content': '使用 OpenAI 服务商时，音频及相关文字会发送至 OpenAI，并依照 OpenAI 的隐私政策处理。',
  'privacy.thirdParty.google.title': 'Google（Gemini）',
  'privacy.thirdParty.google.content': '使用 Gemini 时，音频及相关文字会发送至 Google，并依照 Google 的隐私条款处理。',
  'privacy.thirdParty.palabra.title': 'Palabra',
  'privacy.thirdParty.palabra.content': '使用 Palabra 时，音频及相关文字会发送至 Palabra，并依照 Palabra 的隐私政策处理。',
  'privacy.thirdParty.bytedance.title': '字节跳动（火山引擎）',
  'privacy.thirdParty.bytedance.content': '使用火山引擎语音翻译（豆包）时，音频及相关文字会发送至字节跳动的火山引擎服务，并依照火山引擎的隐私条款处理。',
  'privacy.thirdParty.microsoft.title': '微软',
  'privacy.thirdParty.microsoft.content': '本地推理中的 Edge TTS 和 Bing 翻译会在没有可用的端侧模型时自动使用，您也可以手动选用。使用时，要朗读或翻译的文字会发送至微软，并依照微软的隐私条款处理。',
  'privacy.thirdParty.huggingface.title': 'Hugging Face',
  'privacy.thirdParty.huggingface.content': '您下载端侧模型时，文件从 Hugging Face 获取；Hugging Face 会依照其隐私政策收到您的 IP 地址及请求信息。',
  'privacy.thirdParty.github.title': 'GitHub',
  'privacy.thirdParty.github.content': '桌面应用会向 GitHub 检查更新并从 GitHub 下载新版本；GitHub 会依照其隐私条款收到您的 IP 地址及请求信息。',
  'privacy.transfer.title': '跨境传输',
  'privacy.transfer.content': '上述第三方在多个国家和地区处理信息，包括美国、欧盟、日本、新加坡，以及中国内地（如您为 Qwen 选择北京区域，或使用火山引擎）。使用本服务即表示您知悉您的信息可能被传输至上述国家和地区并在当地处理。',
  'privacy.storage.title': '数据存储与安全',
  'privacy.storage.content': '账户、登录、计费及用量信息存储于 Cloudflare D1，该服务使用 AES-256 对静态数据加密。信息通过加密（TLS）连接传输。',
  'privacy.retention.title': '数据保存期限',
  'privacy.retention.content': '我们按以下期限保存信息：',
  'privacy.retention.items': '账户信息及登录记录：保存至您的账户被删除为止。|防滥用 IP 记录：自该 IP 地址最后一次出现起保存 90 天。|试用额度记录（电子邮箱的单向哈希值，以及领取被拒时匹配到的 IP 地址）：账户删除后仍予保留，以防止重复领取试用额度。|计费及用量记录（包括从 Stripe 收到的付款信息）：在您的账户存续期间保存；账户删除后，按适用的当地法律要求保存。|反馈与通信：保存在我们的客服邮箱中。|保存在您设备上的信息：保存至您在应用中将其删除、清除浏览器数据、删除应用数据文件夹或卸载手机应用为止；导出的文件保留在您保存的位置。',
  'privacy.deletion.title': '账户删除',
  'privacy.deletion.content': '您可随时通过 Kizuna AI 控制台的账户页面删除账户，或使用您的账户邮箱发送邮件至 privacy@kizuna.ai 申请删除。账户删除后：',
  'privacy.deletion.items': '您的电子邮箱、显示名称、登录记录及关联的登录方式将被删除。|克隆音色将被删除，包括 Soniox 处保存的音色。|防滥用 IP 记录按“数据保存期限”一节所述期限删除。|试用额度记录按“数据保存期限”一节所述予以保留。|计费及用量记录（包括从 Stripe 收到的付款信息）按适用的当地法律要求保留。|统计数据经您申请后删除。',
  'privacy.rights.title': '您的权利',
  'privacy.rights.content': '在适用法律允许的范围内，您可通过 privacy@kizuna.ai 联系我们，以：',
  'privacy.rights.items': '访问、更正或删除您的个人信息|获取您的个人信息副本|申请删除您的统计数据|反对或要求限制特定处理|询问您的信息如何被使用',
  'privacy.gdpr.title': '处理的法律依据（欧洲经济区及英国）',
  'privacy.gdpr.content': '如您位于欧洲经济区或英国，我们基于以下依据处理个人信息：为履行与您的合同（提供账户及计费）；基于我们的正当利益（保障本服务安全、防止滥用及改进本服务）；以及为履行法律义务（如保存计费记录）。您亦可向当地数据保护机构提出投诉。',
  'privacy.children.title': '儿童隐私',
  'privacy.children.content': '本服务不面向 13 岁以下儿童，我们不会在知情的情况下收集 13 岁以下儿童的个人信息。',
  'privacy.changes.title': '本隐私政策的变更',
  'privacy.changes.content': '我们可能不时更新本隐私政策。更新后的政策将发布于本页面，并相应修改上方的“最后更新”日期。',
  'privacy.contact.title': '联系我们',
  'privacy.contact.content': '如您对本隐私政策有任何疑问：',
  'privacy.contact.email': '电子邮件：contact@kizuna.ai',
  'privacy.contact.privacy': '隐私请求：privacy@kizuna.ai',
  'privacy.contact.github': 'GitHub：github.com/kizuna-ai-lab/sokuji',

  // Terms of Service
  'tos.title': '服务条款',
  'tos.lastUpdated': '最后更新：2026年10月21日',

  'tos.intro.title': '引言与接受',
  'tos.intro.content': '欢迎使用 Sokuji（以下简称"本服务"），这是由 Kizuna AI Lab（以下简称"公司"、"我们"）提供的实时 AI 翻译应用程序。本服务条款（以下简称"条款"）适用于您对我们浏览器扩展、桌面应用程序及相关服务的访问和使用。',
  'tos.intro.agreement': '下载、安装、访问或使用 Sokuji，即表示您同意受本条款约束。如果您不同意本条款，请勿使用本服务。',

  'tos.definitions.title': '定义',
  'tos.definitions.items': '"本服务"指 Sokuji 应用程序，包括浏览器扩展、桌面应用程序及所有相关功能。|"用户"、"您"指访问或使用本服务的任何个人或实体。|"余额"指从 Kizuna AI Lab 购买的、以美元（USD）计价的预付余额，用于访问 Kizuna AI 提供的翻译服务。|"第三方 API 密钥"指用户直接从第三方 AI 服务提供商（如 OpenAI、Google、Palabra AI）获取的 API 凭证。|"Kizuna AI 服务"指通过 Kizuna AI Lab 基础设施提供的、从您的余额中扣费的 AI 翻译服务。',

  'tos.service.title': '服务说明',
  'tos.service.overview': 'Sokuji 通过两种使用模式提供实时 AI 翻译服务：',
  'tos.service.freeUsage.title': '免费使用模式（第三方 API 密钥）',
  'tos.service.freeUsage.items': '用户可以连接自己的 API 密钥，支持多个 AI 提供商（OpenAI、Google Gemini、Soniox、Qwen LiveTranslate、Palabra AI 等）|Kizuna AI Lab 不收取任何费用；用户直接由其选择的 AI 提供商计费|用户负责管理其 API 密钥的安全和使用限制',
  'tos.service.tokenUsage.title': '预付余额模式（Kizuna AI 服务）',
  'tos.service.tokenUsage.items': '用户向 Kizuna AI Lab 购买以美元（USD）计价的预付余额|使用 Kizuna AI 提供的翻译服务时，将从您的余额中扣费|翻译按 AI 服务商计量的实际用量计费，金额取决于您选择的服务商|钱包页面会显示预估的小时费率；由于按实际用量计费，实际金额通常低于预估',

  'tos.account.title': '账户注册',
  'tos.account.age': '您必须年满13周岁才能使用本服务。如果您未满18周岁，即表示您已获得父母或监护人的许可使用本服务。使用本服务即表示您声明并保证符合此年龄要求。',
  'tos.account.content': '要访问某些功能（包括基于余额的服务），您必须创建账户。您同意：',
  'tos.account.items': '在注册时提供准确、最新、完整的信息|维护账户凭证的安全|及时更新信息以保持其准确性和时效性|对账户下发生的所有活动承担责任',
  'tos.account.security': '您有责任维护账户密码的保密性并限制对您账户的访问。如发现任何未经授权使用您账户的情况，必须立即通知我们。',
  'tos.account.inactivity': '连续24个月处于非活跃状态（无登录或服务使用）的账户可能会被关闭。我们将在关闭非活跃账户前至少30天发送通知。非活跃账户中剩余的余额将在账户关闭时被没收。',

  'tos.notifications.title': '通知与沟通',
  'tos.notifications.methods': '我们可能通过以下方式向您发送通知：(a) Sokuji 应用内通知；(b) 向您账户关联的电子邮件地址发送邮件；(c) 在我们的网站上发布通知。您有责任保持电子邮件地址的最新状态。',
  'tos.notifications.consent': '创建账户即表示您同意通过上述方式接收我们发送的重要服务相关通知。',

  'tos.tokens.title': '余额与支付',
  'tos.tokens.purchase.title': '余额购买',
  'tos.tokens.purchase.items': '可通过应用内支持的支付方式购买余额|所有价格在购买时以适用货币显示|余额不可在账户之间转让|通过充值增加的余额自该次充值之日起一年内有效',
  'tos.tokens.tax': '显示价格已包含适用的消费税（日本）或增值税。对于在日本境外的购买，可能根据您所在管辖区域适用当地税费。',
  'tos.tokens.expiration': '我们将在余额到期前至少30天发送提醒通知。过期的余额将自动失效，无法恢复、退款或延期。在余额过期前使用余额是您的责任。',
  'tos.tokens.promotional': '我们可能免费向您的账户添加促销余额，例如在您验证邮箱地址时提供的试用额度。促销余额的有效期以发放时的说明为准——邮箱验证试用额度为七（7）天——并先于购买的余额使用。上述 30 天提醒不适用于促销余额：发放通知即为唯一提醒。促销余额不可退款、不可转让，到期后即失效。',
  'tos.tokens.consumption.title': '余额消耗',
  'tos.tokens.consumption.content': '翻译按所用 AI 服务计量的实际用量计费，因此金额取决于服务商与模型。钱包页面会显示预估的小时费率；由于按实际用量计费，实际金额通常低于预估。余额在服务商回报用量后更新，通常在会话结束后不久，而非会话进行中持续扣减。',
  'tos.tokens.refund.title': '退款政策',
  'tos.tokens.refund.items': '未使用余额：可在购买后 14 天内提交未使用余额的退款请求。可能收取手续费。|已消耗余额：已消耗的余额不可退款。|服务故障：如因 Kizuna AI Lab 单独认定的技术问题导致余额被扣除，我们可能会将受影响的金额退还到您的账户，但须满足以下条件：(a) 问题必须在发生后30天内报告；(b) 每个账户每年的退还总额不得超过该日历年购买余额总额的20%；(c) Kizuna AI Lab 保留对何为技术问题以及是否应予退还的唯一解释权和决定权。|退款流程：请发送邮件至 support@kizuna.ai，附上购买详情和退款原因。',

  'tos.thirdParty.title': '免费服务（第三方 API 密钥）',
  'tos.thirdParty.content': '使用第三方提供商的自有 API 密钥时：',
  'tos.thirdParty.items': '您对获取和管理 API 密钥承担全部责任|您必须遵守各第三方提供商的服务条款|您对第三方提供商产生的所有费用负责|API 密钥存储在您的本地设备上，绝不会传输到我们的服务器',
  'tos.thirdParty.noWarranty': '我们不对第三方 AI 服务的可用性、质量或性能作任何保证。第三方服务的任何问题应直接联系相应提供商。',

  'tos.use.title': '使用规范',
  'tos.use.permitted.title': '允许的使用',
  'tos.use.permitted.items': '个人实时翻译|商务沟通翻译|教育目的|无障碍支持',
  'tos.use.prohibited.title': '禁止行为',
  'tos.use.prohibited.items': '将本服务用于任何非法或未经授权的目的|尝试对本服务进行逆向工程、反编译或反汇编|干扰或破坏本服务或服务器|使用本服务传输有害、冒犯性或非法内容|未经授权转售、再许可或商业化本服务的访问权|规避任何安全措施或访问限制|使用自动化系统或机器人超出正常使用范围访问本服务|违反任何适用的法律法规',

  'tos.ip.title': '知识产权',
  'tos.ip.ownership': '本服务（包括所有软件、内容、功能）归 Kizuna AI Lab 所有，受国际版权法、商标法和其他知识产权法保护。',
  'tos.ip.license': '根据本条款，我们授予您有限的、非独占的、不可转让的、可撤销的许可，以将本服务用于个人或内部商业目的。',
  'tos.ip.userContent': '您通过本服务提供的任何内容的所有权归您所有。音频和翻译内容实时处理，我们不会存储。',

  'tos.disclaimer.title': '免责声明',
  'tos.disclaimer.asIs': '服务按"原样"提供',
  'tos.disclaimer.items': '对适销性或特定用途适用性的默示保证|翻译的准确性、可靠性或完整性|不间断或无错误的运行|不含病毒或其他有害组件',
  'tos.disclaimer.accuracy': 'AI 翻译可能包含错误。用户不应仅依赖翻译进行重要沟通、法律文件、医疗信息或安全关键应用。',
  'tos.disclaimer.availability': '我们不保证本服务始终可用。本服务可能受到互联网和电子通信固有的限制、延迟和其他问题的影响。',

  'tos.liability.title': '责任限制',
  'tos.liability.items': 'Kizuna AI Lab 不对任何间接、附带、特殊、后果性或惩罚性损害承担责任|我们的总责任不超过您在索赔前 12 个月内为余额支付的金额|我们不对未经授权访问您账户造成的任何损失负责|我们不对第三方 AI 服务引起的任何问题负责',

  'tos.indemnification.title': '赔偿',
  'tos.indemnification.content': '您同意就因您使用本服务、违反本条款、侵犯第三方权利或使用第三方 API 密钥而产生的任何索赔、损害、损失、责任和费用（包括律师费），对 Kizuna AI Lab 及其高管、董事、员工和代理人进行赔偿并使其免受损害。',

  'tos.termination.title': '终止',
  'tos.termination.byUser.title': '用户终止',
  'tos.termination.byUser.items': '您可以随时停止使用本服务并删除您的账户|任何未使用的余额可能会被没收（受退款政策约束）|您访问本服务的权利将立即终止',
  'tos.termination.byUs.title': '我方终止',
  'tos.termination.byUs.items': '如果您违反本条款，我们可能会暂停或终止您的访问权限|如果您的使用构成安全风险，我们可能会终止|如果法律要求，我们可能会终止|如果我们停止本服务，我们可能会终止',
  'tos.termination.discontinuation': '如果我们完全停止本服务，我们将提前至少30天通知。届时，持有未使用余额的用户可申请按比例退还停止服务前12个月内购买的余额，需扣除手续费。退款申请须在停止服务通知发出后60天内提交。',

  'tos.changes.title': '条款变更',
  'tos.changes.content': '我们可能随时修改本条款。对于重大变更，我们将通过在本页面发布更新的条款、更新"最后更新"日期，以及发送应用内通知或重大变更邮件来通知您。在变更后继续使用本服务即表示接受修改后的条款。',

  'tos.governing.title': '管辖法律与争议解决',
  'tos.governing.informalResolution': '在启动正式法律程序之前，双方同意首先尝试通过善意协商解决任何争议。投诉方应向另一方发送描述争议的书面通知。双方应在此后60天内尝试非正式解决。如争议在此期间无法通过非正式方式解决，任一方可按以下规定进行正式法律行动。',
  'tos.governing.law': '本条款受日本法律管辖并按其解释，不考虑法律冲突条款。',
  'tos.governing.jurisdiction': '因本条款或本服务引起的或与之相关的任何争议，应由日本东京法院专属管辖。',
  'tos.governing.language': '如本条款的英文版本与日文版本有任何不一致，对于日本境内的用户，以日文版本为准。',

  'tos.general.title': '一般条款',
  'tos.general.entireAgreement': '本条款连同我们的隐私政策，构成您与 Kizuna AI Lab 之间关于本服务的完整协议。',
  'tos.general.severability': '如果本条款的任何条款被认定为不可执行，其余条款将继续完全有效。',
  'tos.general.waiver': '我们未能执行本条款的任何权利或条款，不构成对这些权利的放弃。',
  'tos.general.forceMajeure': '对于因超出其合理控制范围的情况而导致的本条款义务的不履行或延迟，Kizuna AI Lab 不承担责任，包括但不限于自然灾害、战争、恐怖主义、暴乱、疫情、政府行为、停电、互联网或电信故障、或第三方服务提供商的故障。',

  'tos.contact.title': '联系方式',
  'tos.contact.content': '如果您对本条款有任何疑问，请联系我们：',
  'tos.contact.legal': '法务：legal@kizuna.ai',
  'tos.contact.support': '客服：support@kizuna.ai',
  'tos.contact.github': 'GitHub：github.com/kizuna-ai-lab/sokuji',

  // Dashboard Navigation
  'dashboard.nav.dashboard': '控制台',
  'dashboard.nav.profile': '个人资料',
  'dashboard.nav.security': '安全设置',
  'dashboard.nav.feedback': '反馈',
  'dashboard.nav.signOut': '退出登录',
  'dashboard.user.fallback': '用户',
  'dashboard.sidebar.collapse': '收起侧边栏',
  'dashboard.sidebar.expand': '展开侧边栏',

  // Dashboard Home
  'dashboard.home.welcomeBack': '欢迎回来，{name}',
  'dashboard.home.subtitle': '管理您的账户设置和偏好',
  'dashboard.home.accountOverview': '账户概览',
  'dashboard.home.accountStatus': '账户状态',
  'dashboard.home.accountDetails': '账户详情',
  'dashboard.home.quickActions': '快捷操作',
  'dashboard.home.name': '姓名',
  'dashboard.home.email': '邮箱',
  'dashboard.home.emailVerified': '邮箱验证',
  'dashboard.home.accountType': '账户类型',
  'dashboard.home.userId': '用户 ID',
  'dashboard.home.created': '创建时间',
  'dashboard.home.lastUpdated': '最后更新',
  'dashboard.home.notSet': '未设置',
  'dashboard.home.verified': '已验证',
  'dashboard.home.notVerified': '未验证',
  'dashboard.home.anonymous': '匿名账户',
  'dashboard.home.registered': '注册账户',
  'dashboard.home.editProfile': '编辑资料',
  'dashboard.home.securitySettings': '安全设置',
  'dashboard.home.na': '暂无',

  // Dashboard Profile
  'dashboard.profile.title': '个人资料设置',
  'dashboard.profile.subtitle': '管理您的个人信息',
  'dashboard.profile.personalInfo': '个人信息',
  'dashboard.profile.personalInfoDesc': '更新您的姓名和基本信息',
  'dashboard.profile.nameLabel': '姓名',
  'dashboard.profile.namePlaceholder': '您的姓名',
  'dashboard.profile.saveChanges': '保存更改',
  'dashboard.profile.profileUpdated': '个人资料更新成功',
  'dashboard.profile.emailAddress': '邮箱地址',
  'dashboard.profile.emailAddressDesc': '管理您的邮箱地址和验证状态',
  'dashboard.profile.currentEmail': '当前邮箱',
  'dashboard.profile.verified': '已验证',
  'dashboard.profile.notVerified': '未验证',
  'dashboard.profile.resendVerification': '重新发送验证邮件',
  'dashboard.profile.verificationSent': '验证邮件已发送！请查收您的邮箱。',
  'dashboard.profile.changeEmailTitle': '更改邮箱地址',
  'dashboard.profile.newEmailLabel': '新邮箱地址',
  'dashboard.profile.newEmailPlaceholder': 'new@email.com',
  'dashboard.profile.newEmailHint': '验证邮件将发送到新地址',
  'dashboard.profile.changeEmail': '更改邮箱',
  'dashboard.profile.emailChangeSent': '验证邮件已发送到您的新邮箱地址，请查收。',

  // Dashboard Security
  'dashboard.security.title': '安全设置',
  'dashboard.security.subtitle': '管理您的密码和账户安全',
  'dashboard.security.changePassword': '更改密码',
  'dashboard.security.changePasswordDesc': '更新您的密码以保护账户安全',
  'dashboard.security.currentPassword': '当前密码',
  'dashboard.security.currentPasswordPlaceholder': '输入当前密码',
  'dashboard.security.newPassword': '新密码',
  'dashboard.security.newPasswordPlaceholder': '最少 8 个字符',
  'dashboard.security.confirmPassword': '确认新密码',
  'dashboard.security.confirmPasswordPlaceholder': '确认新密码',
  'dashboard.security.changePasswordBtn': '更改密码',
  'dashboard.security.activeSessions': '活跃会话',
  'dashboard.security.activeSessionsDesc': '管理您的活跃登录会话（{count} 个活跃）',
  'dashboard.security.current': '当前',
  'dashboard.security.lastActive': '最后活跃：{time}',
  'dashboard.security.loadingSessions': '加载会话中...',
  'dashboard.security.signOutOther': '退出所有其他会话',
  'dashboard.security.deleteAccount': '删除账户',
  'dashboard.security.deleteAccountDesc': '永久删除您的账户和所有相关数据',
  'dashboard.security.deleteWarning': '此操作不可撤销。您的所有数据将被永久删除。',
  'dashboard.security.deleteBtn': '删除我的账户',
  'dashboard.security.deleteConfirmText': '要确认删除，请在下方输入 DELETE：',
  'dashboard.security.deleteConfirmPlaceholder': '输入 DELETE 确认',
  'dashboard.security.cancel': '取消',
  'dashboard.security.anonymousNote': '匿名账户无法更改密码。请先转换为正式账户。',
  'dashboard.security.passwordMinLength': '新密码至少需要 8 个字符',
  'dashboard.security.passwordMismatch': '两次输入的密码不一致',
  'dashboard.security.passwordIncorrect': '当前密码不正确',
  'dashboard.security.passwordSuccess': '密码更改成功。其他会话已退出登录。',
  'dashboard.security.typeDelete': '请输入 DELETE 确认',

  // Dashboard Feedback
  'dashboard.feedback.title': '发送反馈',
  'dashboard.feedback.subtitle': '报告问题、建议功能或分享您的想法。我们会阅读每一条消息，感谢您的反馈！',
  'dashboard.feedback.yourFeedback': '您的反馈',
  'dashboard.feedback.sendingAs': '发送者：{email}',
  'dashboard.feedback.remainingCount': '今日剩余 {remaining}/{limit} 条反馈额度',
  'dashboard.feedback.limitReached': '今日额度已用完，明天可以继续发送反馈。',
  'dashboard.feedback.feedbackType': '反馈类型',
  'dashboard.feedback.bugReport': '问题报告',
  'dashboard.feedback.bugReportDesc': '报告问题或错误',
  'dashboard.feedback.suggestion': '功能建议',
  'dashboard.feedback.suggestionDesc': '建议新功能或改进',
  'dashboard.feedback.other': '其他',
  'dashboard.feedback.otherDesc': '一般反馈或问题',
  'dashboard.feedback.message': '消息内容',
  'dashboard.feedback.messagePlaceholder': '请详细描述您的反馈...',
  'dashboard.feedback.messageHint': '{count}/5000 字符（最少 10 个字符）',
  'dashboard.feedback.sendFeedback': '发送反馈',
  'dashboard.feedback.verificationRequired': '需要验证邮箱',
  'dashboard.feedback.verificationRequiredDesc': '请先验证您的邮箱地址再提交反馈。我们需要已验证的邮箱来回复您的反馈。',
  'dashboard.feedback.goToProfile': '前往个人资料设置',
  'dashboard.feedback.thankYou': '感谢您的反馈！已成功发送。',

  // Dashboard Wallet
  'dashboard.wallet.title': '钱包',
  'dashboard.wallet.subtitle': '管理您的余额和充值',
  'dashboard.wallet.balance': '余额',
  'dashboard.wallet.hoursLeft': '约可用（{scenario}）',
  'dashboard.wallet.hoursLeftAverage': '约可用（按近 30 天平均 {rate}/小时）',
  'dashboard.wallet.hoursValue': '≈ {hours} 小时',
  'dashboard.wallet.recentRecords': '最近记录',
  'dashboard.wallet.allRecords': '全部记录',
  'dashboard.wallet.fullPricing': '完整定价表',
  'dashboard.wallet.plan': '当前套餐',
  'dashboard.wallet.last30Days': '近30天使用',
  'dashboard.wallet.expiringSoon': '${amount} 将于 {date} 过期',
  'dashboard.wallet.expiringSoonPartial': '${amount} 将于 {date} 过期，一个月内共 ${total}',
  'dashboard.wallet.accountFrozen': '您的账户已被冻结，请联系客服。',
  'dashboard.wallet.topUp': '充值',
  'dashboard.wallet.customAmount': '自定义金额',
  'dashboard.wallet.amountRange': '最低：{min} - 最高：{max}',
  'dashboard.wallet.youWillReceive': '您将获得',
  'dashboard.wallet.paymentMethod': '支付方式',
  'dashboard.wallet.methodCard': '银行卡',
  'dashboard.wallet.methodAlipay': '支付宝',
  'dashboard.wallet.continueWithAmount': '前往支付 · {amount}',
  'dashboard.wallet.poweredByStripe': '支付由 Stripe 安全处理。',
  'dashboard.wallet.alipayCharge': '按日元收取 {amount}',
  'dashboard.wallet.alipayRate': '汇率 1 美元 = {rate} 日元（欧洲央行，{date}）',
  'dashboard.wallet.alipayRateChanged': '汇率刚刚更新，请确认新的金额后再试。',
  'dashboard.wallet.otherPaymentMethods': '其他支付方式',
  'dashboard.wallet.processing': '处理中...',
  'dashboard.wallet.pricing.provider': 'Soniox 计费，仅限实时流式传输',

  // THE CALCULATOR. Its scenario presets, and their titles and descriptions,
  // follow kizuna-ai-lab/sokuji's own first-run wizard
  // (`setup.scenarios.*` there) so the dashboard and the app name the same
  // thing the same way, as are /scenarios' `scenario.<id>.title`/`.body`. The
  // two repos cannot share catalogs: `app-scenarios.fixture.ts` pins the
  // wizard's strings and `scenario-copy.test.ts` holds both pages to them, so
  // when the app rewords a scenario, update the fixture and these together.
  'dashboard.wallet.pricing.calcTitle': '费用计算器',
  'dashboard.wallet.pricing.calcScenario': '您打算用它做什么？',
  'dashboard.wallet.pricing.calcEstimate': '预估费用',
  'dashboard.wallet.pricing.calcFactors': '这个预估由什么构成',
  'dashboard.wallet.pricing.scenario.understand-others.title': '听懂对方',
  'dashboard.wallet.pricing.scenario.understand-others.desc': '在线会议、网课、讲座、视频、直播——实时阅读你听到内容的翻译。',
  'dashboard.wallet.pricing.scenario.be-heard.title': '让对方在会议里听懂我',
  'dashboard.wallet.pricing.scenario.be-heard.desc': '对方通过虚拟麦克风听到你翻译后的语音。',
  'dashboard.wallet.pricing.scenario.subtitle-myself.title': '给我的发言配字幕',
  'dashboard.wallet.pricing.scenario.subtitle-myself.desc': '演讲、直播、演示——观众阅读翻译字幕，不生成语音。',
  'dashboard.wallet.pricing.scenario.two-way-voice.title': '在线双向对话',
  'dashboard.wallet.pricing.scenario.two-way-voice.desc': '对方听到你的翻译语音；你看到对方的字幕，也可以听到译音。',
  'dashboard.wallet.pricing.scenario.two-way-text.title': '在线双向对话，只要字幕',
  'dashboard.wallet.pricing.scenario.two-way-text.desc': '双语字幕、会议记录——双方都以文字呈现，不使用合成语音。',
  'dashboard.wallet.pricing.scenario.face-to-face-voice.title': '面对面对话',
  'dashboard.wallet.pricing.scenario.face-to-face-voice.desc': '两个人在同一台电脑前，各说各的语言；每人戴一只耳机，只听到翻译成自己语言的内容。',
  'dashboard.wallet.pricing.scenario.face-to-face-text.title': '面对面对话，只要字幕',
  'dashboard.wallet.pricing.scenario.face-to-face-text.desc': '两人看同一块屏幕，或者对方在手机上打开 LAN 字幕页面。',
  'dashboard.wallet.pricing.engine': '引擎',
  'dashboard.wallet.pricing.region': '地区',
  'dashboard.wallet.pricing.regionSg': '新加坡',
  'dashboard.wallet.pricing.regionCn': '北京',
  'dashboard.wallet.pricing.scenario.custom.title': '自定义',
  'dashboard.wallet.pricing.scenario.custom.desc': '下面几项按你自己的用法设置。改动任何一项都会切到这里。',
  'dashboard.wallet.pricing.sideThem': '对方说的话',
  'dashboard.wallet.pricing.sideMe': '我说的话',
  'dashboard.wallet.pricing.output.off': '不翻译',
  'dashboard.wallet.pricing.output.text': '显示字幕',
  'dashboard.wallet.pricing.output.voiceThem': '读给我听',
  'dashboard.wallet.pricing.output.voiceMe': '读给对方听',
  'dashboard.wallet.pricing.shareThem': '对方说话的时间',
  'dashboard.wallet.pricing.shareMe': '我说话的时间',
  'dashboard.wallet.pricing.shareValue': '{count}% · 每小时约 {minutes} 分钟',
  'dashboard.wallet.pricing.screenContext': '屏幕上下文',
  'dashboard.wallet.pricing.screenContextHint': 'Qwen 引擎会看到您选定的一个窗口、标签页或屏幕；按说话时长计费，每个方向单独计算。',
  'dashboard.wallet.pricing.balanceLasts': '余额 {balance} 约够 {hours} 小时',
  'dashboard.wallet.pricing.balanceLastsUnderOne': '余额 {balance} 不够一小时',
  'dashboard.wallet.pricing.trait.soniox': '60 种语言互译，字幕和配音都支持；可选预设声音，也可以录一段声音做成自己的声音；支持面对面（一台电脑两个人）。',
  'dashboard.wallet.pricing.trait.qwen': '可以用说话人自己的声音读出译文，每一句实时复刻，不用先录声音；29 种语言可以读出来，60 种可以出字幕。',
  'dashboard.wallet.pricing.sharedActive': '按一条共享流估算：面对面时两个方向共用一条连接。',
  'dashboard.wallet.pricing.sharedHint': '面对面对话，或双方共用一条流：少一条连接，每小时便宜约 {amount}。',
  'dashboard.wallet.pricing.needOneSide': '至少要翻译一方的话。',
  'dashboard.wallet.pricing.partConnection': '连接 × {count} 条',
  'dashboard.wallet.pricing.partText': '文字',
  'dashboard.wallet.pricing.partVoice': '配音',
  'dashboard.wallet.pricing.partScreen': '屏幕上下文',
  'dashboard.wallet.pricing.partTotal': '合计',
  'dashboard.wallet.pricing.colItem': '项',
  'dashboard.wallet.pricing.colUnitPrice': '单价',
  'dashboard.wallet.pricing.colHourly': '每小时用量',
  'dashboard.wallet.pricing.usePerConnectedHour': '连接一小时 {count} token',
  'dashboard.wallet.pricing.usePerSpeechHour': '说话一小时 {count} token',
  'dashboard.wallet.pricing.usePerSpokenHour': '读出一小时 {count} token',
  'dashboard.wallet.pricing.usePerScreenHour': '开启屏幕上下文时，说话一小时 {count} token',
  'dashboard.wallet.pricing.providerQwen': '{name} 计费，仅限实时流式传输',

  'dashboard.wallet.pricing.perHourApprox': '≈ {amount}/小时',
  'dashboard.wallet.pricing.assumptions': '每个被翻译的方向是一条连接，连着的每一分钟都计费，不论有没有人说话。文字按被翻译的人说话的时间计费；配音只算读出来的部分。每个人的说话时间单独设置，所以打开一方只会加上这一方的费用。',
  'dashboard.wallet.pricing.settlement': '这些数字是估算值，不是报价。您实际支付的费用以引擎针对您本次会话报告的 token 数量为准。',
  'dashboard.wallet.pricing.rateInputAudio': '输入音频 token',
  'dashboard.wallet.pricing.rateOutputText': '输出文本 token',
  'dashboard.wallet.pricing.rateTtsInputText': '输入文本 token',
  'dashboard.wallet.pricing.rateTtsOutputAudio': '输出音频 token',
  'dashboard.wallet.pricing.rateInputImage': '输入图像 token（屏幕上下文）',
  'dashboard.wallet.pricing.perMillion': '{amount} / 每百万 token',
  'dashboard.wallet.pricing.cnyPerMillion': '¥{amount} / 每百万 token',
  'dashboard.wallet.pricing.fxNote': '按 {date} 的欧洲央行汇率换算：1 美元 = {rate} 人民币。汇率每日更新。',
  'dashboard.wallet.pricing.sttReference': '1小时音频约为30,000个输入音频 token • 1小时语音约为15,000个输出文本 token • 每个输出字符约为0.3个 token',
  'dashboard.wallet.pricing.ttsReference': '1个字符 ≈ 0.3个输入文本 token • 15,000个输入文本 token ≈ 1小时生成语音 • 1小时生成语音 ≈ 30,000个输出音频 token',
  'dashboard.wallet.pricing.referenceNote': '引用自提供商。翻译会同时生成转写文本和译文，因此1小时语音产生的输出文本 token 约为上述数字的两倍——这也是表格中使用的数字。',
  'dashboard.wallet.pricing.readOn': '提供商价格读取于 {date}。',
  'dashboard.wallet.pricing.error': '无法加载价格',
  'dashboard.wallet.pricing.retry': '重试',
  'dashboard.wallet.pricing.boundariesHeading': '您因何付费',
  'dashboard.wallet.pricing.boundaryConnection': '已连接的流无论是否有人说话都会计费。仅连接本身，每路流每小时约消耗{count}个输入音频 token；说话会在此基础上增加输出文本。',
  'dashboard.wallet.pricing.boundaryReservation': '开始一次会话会按保守费率预留足够的余额以覆盖费用，这一预留决定了会话可运行的时长。您的余额只会因实际使用量而变动，预留中未使用的部分绝不会被扣除。',
  'dashboard.wallet.pricing.boundaryCurrency': '所有金额均以美元计。',
  'dashboard.wallet.pricing.faqHeading': '常见问题',
  'dashboard.wallet.pricing.faqTranslationQ': '翻译是否单独收费？',
  'dashboard.wallet.pricing.faqTranslationA': '不会。转写和翻译在同一路流中完成，翻译费用已包含在上述费率中。',
  'dashboard.wallet.pricing.faqFeaturesQ': '说话人分离、语言检测和格式化是否需要额外付费？',
  'dashboard.wallet.pricing.faqFeaturesA': '不需要。说话人分离、语言识别和智能格式化均已包含在内，不产生额外费用。',
  'dashboard.billing.title': '账单',
  'dashboard.billing.subtitle': '您的余额、额度与付款',
  'dashboard.usage.title': '用量',
  'dashboard.usage.subtitle': '会话消耗的明细',
  'dashboard.usage.sessionTime': '会话时长',
  'dashboard.usage.sessions': '场会话',
  'dashboard.usage.chartStart': '{{days}} 天前',
  'dashboard.usage.chartEnd': '今天',
  'dashboard.usage.chartLabel': '窗口内每日花费',
  'dashboard.usage.noSpend': '无用量',
  'dashboard.wallet.ledger.billingTitle': '账单记录',
  'dashboard.wallet.ledger.viewReceipt': '查看收据',
  'dashboard.wallet.lots.title': '额度',
  'dashboard.wallet.lots.totalRemaining': '可用',
  'dashboard.wallet.lots.colCreated': '添加时间',
  'dashboard.wallet.lots.colAmount': '金额',
  'dashboard.wallet.lots.colUsed': '已用',
  'dashboard.wallet.lots.colRemaining': '剩余',
  'dashboard.wallet.lots.colExpires': '过期时间',
  'dashboard.wallet.lots.colStatus': '状态',
  'dashboard.wallet.lots.status.active': '有效',
  'dashboard.wallet.lots.status.expiring': '即将过期',
  'dashboard.wallet.lots.status.spent': '已用完',
  'dashboard.wallet.lots.status.expired': '已过期',
  'dashboard.wallet.lots.empty': '暂无额度。',
  'dashboard.wallet.lots.error': '无法加载您的额度。',
  'dashboard.wallet.lots.retry': '重试',
  'dashboard.wallet.paymentHistory': '充值记录',
  'dashboard.wallet.noHistory': '暂无充值记录',
  'dashboard.wallet.loading': '加载钱包中...',
  'dashboard.wallet.paymentSuccess': '支付成功！您的余额已更新。',
  'dashboard.wallet.paymentUnavailable': '在线支付暂时不可用，请稍后再试。',
  'dashboard.wallet.errorFetchingBalance': '获取钱包余额失败',
  'dashboard.wallet.minAmountError': '最低金额为 {min}',
  'dashboard.wallet.maxAmountError': '最高金额为 {max}',
  'dashboard.wallet.paymentError': '支付失败，请重试。',

  // Dashboard Wallet — billing ledger
  'dashboard.wallet.ledger.title': '交易记录',
  'dashboard.wallet.ledger.kind.sttSpeaker': '我的语音识别',
  'dashboard.wallet.ledger.kind.sttParticipant': '对方语音识别',
  'dashboard.wallet.ledger.kind.translateSpeaker': '我的语音翻译',
  'dashboard.wallet.ledger.kind.translateParticipant': '对方语音翻译',
  'dashboard.wallet.ledger.kind.sttMixed': '混合语音识别',
  'dashboard.wallet.ledger.kind.stt': '语音识别',
  'dashboard.wallet.ledger.kind.tts': '语音合成',
  'dashboard.wallet.ledger.kind.ttsPreview': '语音试听',
  'dashboard.wallet.ledger.kind.topup': '充值',
  'dashboard.wallet.ledger.kind.grant': '赠送',
  'dashboard.wallet.ledger.kind.adjustment': '账户调整',
  'dashboard.wallet.ledger.kind.refund': '退款',
  'dashboard.wallet.ledger.kind.expired': '余额过期',
  'dashboard.wallet.ledger.kind.usage': '使用',
  'dashboard.wallet.ledger.kind.voicePreview': '语音试听',
  'dashboard.wallet.ledger.group.session': '翻译会话',
  'dashboard.wallet.ledger.mode.me': '我',
  'dashboard.wallet.ledger.mode.other': '对方',
  'dashboard.wallet.ledger.mode.both': '两者',
  'dashboard.wallet.ledger.textOnly': '仅文本',
  'dashboard.wallet.ledger.poweredBy': '{name} 驱动',
  'dashboard.wallet.engine.qwenSingapore': 'Qwen (新加坡)',
  'dashboard.wallet.engine.qwenBeijing': 'Qwen (北京)',
  'dashboard.wallet.ledger.segments': '段',
  'dashboard.wallet.ledger.prevPage': '上一页',
  'dashboard.wallet.ledger.nextPage': '下一页',
  'dashboard.wallet.ledger.prevPageAria': '上一页',
  'dashboard.wallet.ledger.nextPageAria': '下一页',
  'dashboard.wallet.ledger.page': '第 {page} 页',
  'dashboard.wallet.ledger.empty': '还没有任何交易记录',
  'dashboard.wallet.ledger.error': '无法加载交易记录',
  'dashboard.wallet.ledger.retry': '重试',
  'dashboard.wallet.ledger.expandRow': '展开明细',
  'dashboard.wallet.ledger.collapseRow': '收起明细',

  // Dashboard Navigation - Wallet
  'dashboard.nav.wallet': '钱包',
  'dashboard.nav.billing': '账单',
  'dashboard.nav.usage': '用量',

  // Commerce Disclosure (特定商取引法に基づく表記)
  'commerce.title': '商业信息披露',
  'commerce.lastUpdated': '最后更新：2026年10月6日',

  // Operator Information
  'commerce.operator.title': '经营者信息',
  'commerce.operator.name.label': '经营者名称',
  'commerce.operator.name.value': 'Kizuna AI Lab',
  'commerce.operator.representative.label': '运营负责人',
  'commerce.operator.representative.value': 'SHINONOME TAKU',
  'commerce.operator.address.label': '地址',
  'commerce.operator.address.value': '收到请求后将及时披露',
  'commerce.operator.phone.label': '电话号码',
  'commerce.operator.phone.value': '收到请求后将及时披露（请通过电子邮件联系我们）',
  'commerce.operator.email.label': '电子邮箱',
  'commerce.operator.email.value': 'support@kizuna.ai',
  'commerce.operator.url.label': '网址',
  'commerce.operator.url.value': 'https://sokuji.kizuna.ai',

  // Price
  'commerce.price.title': '价格',
  'commerce.price.description': '价格如下。所有价格均含税。',
  'commerce.price.items': '预付余额以美元（USD）计价；您支付的金额将计入余额|翻译按您所选 AI 服务商计量的实际用量计费；钱包页面会显示预估的小时费率|最低购买金额：5 美元|最高购买金额：100 美元',
  'commerce.price.tax': '日本境内用户：价格已包含消费税。日本境外用户：根据您所在地区，可能需要缴纳当地税费。',

  // Additional Fees
  'commerce.additionalFees.title': '额外费用',
  'commerce.additionalFees.description': '使用本服务除充值余额的费用外，不产生任何额外费用。',

  // Payment
  'commerce.payment.title': '支付方式',
  'commerce.payment.items': '信用卡|借记卡|Apple Pay|Google Pay|Link|支付宝（Alipay）',
  'commerce.payment.note': '支付通过 Stripe, Inc. 处理。可用的支付方式可能因 Stripe 的支持情况而有所不同。选择支付宝时按日元收款，金额由美元按付款前显示的欧洲央行参考汇率换算。',

  // Payment Period
  'commerce.paymentPeriod.title': '支付期限',
  'commerce.paymentPeriod.content': '信用卡和支付宝支付在购买完成后立即处理。',

  // Delivery
  'commerce.delivery.title': '服务提供时间',
  'commerce.delivery.items': '付款完成后，预付余额将立即计入您的账户|AI 翻译服务实时提供；余额在服务商回报用量后按实际用量扣费，通常在会话结束后不久|您的余额自购买之日起 1 年内有效',

  // Refund / Exchange Policy
  'commerce.refund.title': '退换货政策',
  'commerce.refund.customerRequest.title': '＜客户原因的退换货＞',
  'commerce.refund.customerRequest.content': '由于数字服务的性质，购买后的预付余额原则上不接受退换货。但对于未使用的余额，可在购买后14天内申请退款，可能收取手续费。如需申请退款，请将购买详情和退款原因发送至 support@kizuna.ai。',
  'commerce.refund.defect.title': '＜产品缺陷/服务故障的退换货＞',
  'commerce.refund.defect.content': '如因技术问题导致服务未能正常提供，或余额扣费有误，请联系 support@kizuna.ai。经调查后，受影响的金额将被返还到您的账户。',

  // Environment
  'commerce.environment.title': '系统要求',
  'commerce.environment.items': '浏览器扩展：Chrome 116+、Edge 116+（基于Chromium）|桌面应用：Windows 10+、macOS 13+、Linux（推荐Ubuntu 20.04+）|网络连接：需要稳定的宽带连接|麦克风：语音翻译需要音频输入设备',

  // Contact
  'commerce.contact.title': '联系我们',
  'commerce.contact.description': '如有问题或咨询，请通过以下方式联系我们。',
  'commerce.contact.email': '邮箱：support@kizuna.ai',
  'commerce.contact.github': 'GitHub：github.com/kizuna-ai-lab/sokuji',

  // Participant Audio Feature
  'nav.participantAudio': '对方音频',

  // Overview

  // How It Works

  // Platform Support

  // How to Enable

  // Platform Differences

  // Tips

  // FAQ

  // Device Selection Guide

  // Uninstall Feedback
  'uninstall.loading': '正在加载问卷...',
  'uninstall.retry': '重试',
  'uninstall.fallbackTitle': '很遗憾看到您离开',
  'uninstall.fallbackSubtitle': '请选择所有适用的原因。您的反馈将帮助我们改进。',
  'uninstall.otherPlaceholder': '请详细说明...',
  'uninstall.submitButton': '提交反馈',
  'uninstall.tryDesktop': '试试 {link} — 更多功能，适用于任何应用',
  'uninstall.thankyouTitle': '感谢您的反馈！',
  'uninstall.thankyouSubtitle': '感谢您抽出宝贵时间分享您的想法。您的反馈将帮助我们为未来的用户改进 Sokuji。',
  'uninstall.reinstallPrompt': '改变主意了？您随时可以重新安装 Sokuji。',
  'uninstall.reinstallButton': '从 Chrome 网上应用店重新安装',
  'uninstall.needMoreFeatures': '需要更多功能？',
  'uninstall.needMoreFeaturesDesc': '如果您遇到不支持的网站或想使用自定义 API 提供商，请试试我们的桌面客户端！',
  'uninstall.tryDesktopClient': '试用 Sokuji 桌面版',
  'uninstall.getInTouch': '联系我们',
  'uninstall.reportBug': '报告问题：',
  'uninstall.shareIdea': '分享建议：',
  'uninstall.copyright': '© {year} Sokuji. 保留所有权利。',

  // Subtitle Mode Feature
  'nav.subtitleMode': '字幕模式',
  'nav.basicFeatures': '基本功能',
  'nav.feature.translationModes': '翻译模式',
  'nav.feature.virtualMicrophone': '虚拟麦克风',
  'nav.feature.textOnly': '朗读或仅文字',
  'nav.feature.display': '显示设置',
  'nav.feature.pronunciationReadings': '读音标注',
  'nav.feature.export': '导出和自动保存',
  'nav.feature.replay': '重播',
  'nav.feature.noiseSuppression': '噪声抑制',
  'nav.feature.passthrough': '原声直通',
  'nav.feature.switchDevices': '切换设备',
  'nav.feature.diagnosticLogs': '诊断日志',
  'nav.feature.interfaceLanguage': '界面语言',
  'nav.feature.captionSharing': '字幕分享',

  // Overview

  // How to enter and exit

  // Floating bar layout

  // Customization

  // Pin and Lock

  // Compact vs. expanded rows

  // Tips and limitations

  // FAQ

  // 管理后台（扁平 key，与 Phases 3/4/5 中 t('admin.*') 调用一一对应）
  'admin.badge': 'Sokuji 管理后台',
  'admin.user.fallback': '管理员',
  'admin.nav.wallet': '钱包',
  'admin.nav.users': '用户',
  'admin.nav.signOut': '退出登录',
  'admin.nav.backToDashboard': '返回控制台',
  'admin.sidebar.collapse': '收起侧边栏',
  'admin.sidebar.expand': '展开侧边栏',
  'admin.unauthorized.title': '没有权限',
  'admin.unauthorized.message': '您的账户无权访问管理后台。',
  'admin.error.generic': '出错了，请重试。',

  // 钱包 — 搜索
  'admin.wallet.searchTitle': '钱包管理',
  'admin.wallet.searchSubtitle': '按邮箱或用户 ID 查找用户，以查看并调整其钱包。',
  'admin.wallet.searchLabel': '邮箱或用户 ID',
  'admin.wallet.lookup': '查找',
  'admin.wallet.notFound': '未找到对应邮箱或 ID 的用户。',
  'admin.wallet.loading': '加载中…',
  'admin.wallet.backToSearch': '← 返回搜索',

  // 钱包 — 详情
  'admin.wallet.balance': '余额',
  'admin.wallet.last30Days': '近 30 天用量',
  'admin.wallet.recentLedger': '最近活动',
  'admin.wallet.topUpHistory': '充值记录',
  'admin.wallet.fullLedger': '查看完整账本 →',

  // 钱包 — 调整表单
  'admin.wallet.adjustTitle': '充值 / 退款',
  'admin.wallet.action': '操作',
  'admin.wallet.credit': '充值（增加）',
  'admin.wallet.refund': '退款（扣减）',
  'admin.wallet.amountUsd': '金额（美元，如 12.34）',
  'admin.wallet.note': '备注（可选）',
  'admin.wallet.apply': '应用',
  'admin.wallet.confirmTitle': '确认调整',
  // {amount} 会被替换为带符号的实际金额，例如 "+$20.00"。
  'admin.wallet.confirmMessage': '确认为该钱包应用 {amount}？',
  'admin.wallet.adjustSuccess': '余额已更新',

  // 管理后台 — 钱包冻结/解冻（SP4）
  'admin.wallet.freeze': '冻结钱包',
  'admin.wallet.unfreeze': '解冻钱包',
  'admin.wallet.freezeConfirmTitle': '确认冻结该钱包？',
  'admin.wallet.unfreezeConfirmTitle': '确认解冻该钱包？',
  'admin.wallet.freezeConfirmMessage': '冻结后将阻止新会话，并在下一个计费片段（约 30 秒）内停止进行中的会话。',
  'admin.wallet.unfreezeConfirmMessage': '解冻后该用户可重新发起中继会话。',
  'admin.wallet.freezeSuccess': '钱包已冻结',
  'admin.wallet.unfreezeSuccess': '钱包已解冻',

  // 账本
  'admin.ledger.title': '账本',
  'admin.ledger.backToWallet': '← 返回钱包',
  'admin.lots.title': '余额批次',
  'admin.lots.credited': '入账时间',
  'admin.lots.amount': '金额',
  'admin.lots.remaining': '剩余',
  'admin.lots.expires': '到期时间',
  'admin.lots.reminded': '已提醒',
  'admin.lots.status': '状态',
  'admin.lots.status.active': '有效',
  'admin.lots.status.expiring': '即将到期',
  'admin.lots.status.spent': '已用完',
  'admin.lots.status.expired': '已过期',
  'admin.lots.empty': '暂无余额批次。',
  'admin.lots.inconsistent': '该帐户的批次与流水不一致。两个每日过期作业都会跳过它，因此它既不会收到提醒也不会被清算——在修复之前其余额不会过期。',
  'admin.ledger.when': '时间',
  'admin.ledger.type': '类型',
  'admin.ledger.amount': '数量',
  'admin.ledger.ref': '关联',
  'admin.ledger.description': '描述',
  'admin.ledger.empty': '暂无账本记录。',

  // 充值
  'admin.payments.credit': '充值（美元）',
  'admin.payments.usd': '美元',
  'admin.payments.empty': '暂无充值。',

  // 用户 — 列表
  'admin.users.title': '用户',
  'admin.users.subtitle': '按邮箱、姓名或 ID 搜索用户。',
  'admin.users.searchLabel': '搜索',
  'admin.users.searchPlaceholder': '邮箱、姓名或 ID',
  'admin.users.filterVerified': '邮箱已验证',
  'admin.users.filterPaid': '付费',
  'admin.users.filterAny': '全部',
  'admin.users.verified': '已验证',
  'admin.users.unverified': '未验证',
  'admin.users.anonymous': '匿名',
  'admin.users.paid': '已付费',
  'admin.users.unpaid': '未付费',
  'admin.users.sortLabel': '排序',
  'admin.users.sort.created_desc': '最新优先',
  'admin.users.sort.created_asc': '最早优先',
  'admin.users.sort.email_asc': '邮箱（A–Z）',
  'admin.users.sort.last_active_desc': '最近活跃优先',
  'admin.users.sort.last_active_asc': '最久未活跃优先',
  'admin.users.sort.balance_desc': '余额从高到低',
  'admin.users.sort.balance_asc': '余额从低到高',
  'admin.users.colEmail': '邮箱',
  'admin.users.colName': '姓名',
  'admin.users.colStatus': '状态',
  'admin.users.colBalance': '余额',
  'admin.users.colLastActive': '最后活跃',
  'admin.users.colCreated': '创建时间',
  'admin.users.empty': '未找到用户。',
  'admin.users.view': '查看 →',

  // 分页
  'admin.pagination.prev': '上一页',
  'admin.pagination.next': '下一页',
  'admin.pagination.prevAria': '上一页',
  'admin.pagination.nextAria': '下一页',
  'admin.pagination.rows': '每页',
  'admin.pagination.page': '页码',

  // 用户 — 详情
  'admin.users.notFound': '未找到对应 ID 的用户。',
  'admin.users.loading': '加载用户中…',
  'admin.users.backToList': '← 返回用户列表',
  'admin.users.identity': '身份信息',
  'admin.users.manageWallet': '管理钱包 →',
  'admin.users.fieldId': '用户 ID',
  'admin.users.fieldEmail': '邮箱',
  'admin.users.fieldName': '姓名',
  'admin.users.fieldCreated': '创建时间',
  'admin.users.fieldUpdated': '更新时间',
  'admin.users.providers': '已关联的登录方式',
  'admin.users.providersEmpty': '暂无关联的登录方式。',
  'admin.users.providerId': '提供方',
  'admin.users.providerAccount': '账户 ID',
  'admin.users.linkedAt': '关联时间',
  'admin.users.sessions': '最近登录会话',
  'admin.users.sessionsEmpty': '暂无最近会话。',
  'admin.users.sessionStarted': '开始时间',
  'admin.users.sessionExpires': '过期时间',
  'admin.users.sessionIp': 'IP',
  'admin.users.sessionLocation': '位置',
  'admin.users.sessionDevice': '设备',
  'admin.users.viewInPostHog': 'PostHog',

  // 管理后台 — 登录地址（user_ips）
  'admin.users.addresses': '登录地址',
  'admin.users.addressesWindow': '最后一次出现后保留 {days} 天，之后清理——不等于账号的全部历史。',
  'admin.users.addressesEmpty': '该用户暂无地址记录。',
  'admin.users.addressesTruncated': '仅显示最近的地址——该用户还有更多。',
  'admin.users.ipAddress': '地址',
  'admin.users.ipFirstSeen': '首次出现',
  'admin.users.ipLastSeen': '最后出现',
  'admin.users.ipSightings': '出现次数',
  'admin.users.ipSightingsHelp': '在该地址上记录到的登录与会话开始次数。',
  'admin.users.ipUserCount': '用户数',
  'admin.users.ipOthers': '同地址的其他用户',
  'admin.users.ipNeighbourDeleted': '已删除',
  'admin.users.ipNeighbourDeletedHelp': '账号已删除，但地址记录保留。',
  'admin.users.ipMoreUsers': '还有 {count} 人',
  'admin.users.ipShowFewer': '收起',
  'admin.users.ipShowingOf': '已显示 {shown} / {total}。',

  // 管理后台 — 数据分析（SP3）
  'admin.nav.analytics': '数据分析',
  'admin.analytics.title': '数据分析',
  'admin.analytics.subtitle': '平台整体的收入与用量。',
  'admin.analytics.posthogSignpost': '用户活跃度数据保存在 PostHog 中',
  'admin.analytics.rangeLabel': '时间范围',
  'admin.analytics.rangeDays': '{days} 天',
  'admin.analytics.kpiRevenue': '收入',
  'admin.analytics.kpiUsage': '用量',
  'admin.analytics.kpiPaying': '付费用户',
  'admin.analytics.kpiMargin': '利润',
  'admin.analytics.revenueChart': '每日收入（美元）',
  'admin.analytics.usageChart': '每日用量（美元）',
  'admin.analytics.spenders24hTitle': '24 小时消费最高用户',
  'admin.analytics.spenders24hEmpty': '过去 24 小时内暂无消费。',
  'admin.analytics.topUpsTitle': '最近充值',
  'admin.analytics.topUpsEmpty': '暂无充值记录。',
  'admin.analytics.colUser': '用户',
  'admin.analytics.colUsage24h': '24 小时消费',
  'admin.analytics.colBalance': '余额',
  'admin.analytics.colAmount': '充值金额',
  'admin.analytics.colTime': '时间（UTC）',
  'admin.analytics.colUserTopUps': '累计充值次数',
  'admin.analytics.viewUser': '查看 →',
  'admin.analytics.viewAll': '查看全部 →',
  'admin.analytics.backToAnalytics': '返回数据分析',
  'admin.analytics.spendersListSubtitle': '过去 24 小时内有消费的所有用户，按消费从高到低排列。',
  'admin.analytics.topUpsListTitle': '全部充值',
  'admin.analytics.topUpsListSubtitle': '所有付费充值，最新的在前。赠送额度和管理员调整不算充值，不在此列。',

  // 管理后台 — 会话（SP4）
  'admin.nav.sessions': '会话',
  'admin.sessions.title': '会话',
  'admin.sessions.subtitle': '进行中的会话来自会话租约，已结束的来自计量用量。Soniox 在会话结束后才计费，所以进行中的行暂无用量。',
  'admin.sessions.windowLabel': '时间窗口',
  'admin.sessions.windowMinutes': '{minutes} 分钟',
  'admin.sessions.refresh': '刷新',
  'admin.sessions.generatedAt': '截至 {time}',
  'admin.sessions.colUser': '用户',
  'admin.sessions.colProvider': '提供方',
  'admin.sessions.colStreams': '流',
  'admin.sessions.streamPending': '已签发密钥，流尚未连接',
  'admin.sessions.colUsage': '用量（美元）',
  'admin.sessions.colStarted': '开始时间',
  'admin.sessions.colDuration': '时长',
  'admin.sessions.colStatus': '状态',
  'admin.sessions.mode.text_only': '仅文本',
  'admin.sessions.mode.speech_to_speech': '语音',
  'admin.sessions.mode.voice_preview': '语音试听',
  'admin.sessions.statusLive': '进行中',
  'admin.sessions.statusEnding': '结束中',
  'admin.sessions.statusEnded': '已结束',
  'admin.sessions.viewUser': '查看 →',
  'admin.sessions.empty': '该时间窗口内暂无会话。',

  // Admin console — Qwen key pool
  'admin.nav.qwenKeys': 'Qwen 密钥',
  'admin.qwenKeys.title': 'Qwen 密钥',
  'admin.qwenKeys.subtitle': '托管 Qwen LiveTranslate 密钥池：一个密钥同一时间只服务一个会话，并在令牌有效期内被占用。',
  'admin.qwenKeys.refresh': '刷新',
  'admin.qwenKeys.filterWorkspace': '工作空间',
  'admin.qwenKeys.allWorkspaces': '全部工作空间',
  'admin.qwenKeys.sumWorkspaces': '工作空间',
  'admin.qwenKeys.sumActive': '启用的密钥',
  'admin.qwenKeys.sumHeld': '占用中',
  'admin.qwenKeys.sumFree': '空闲',
  'admin.qwenKeys.sumSessions': '本分钟会话数',
  'admin.qwenKeys.sumAlarms': '未处理告警',
  'admin.qwenKeys.workspacesTitle': '工作空间',
  'admin.qwenKeys.keysTitle': '密钥',
  'admin.qwenKeys.auditTitle': '审计，近 14 天',
  'admin.qwenKeys.auditEmpty': '没有需要关注的项目。',
  'admin.qwenKeys.noWorkspaces': '暂无工作空间。',
  'admin.qwenKeys.noKeys': '暂无密钥。',
  'admin.qwenKeys.addWorkspace': '添加工作空间',
  'admin.qwenKeys.addKey': '添加密钥',
  'admin.qwenKeys.add': '添加',
  'admin.qwenKeys.cancel': '取消',
  'admin.qwenKeys.replace': '替换',
  'admin.qwenKeys.replaceSecret': '替换密钥内容',
  'admin.qwenKeys.editLabel': '修改标签',
  'admin.qwenKeys.save': '保存',
  'admin.qwenKeys.pause': '暂停',
  'admin.qwenKeys.resume': '恢复',
  'admin.qwenKeys.paused': '已暂停',
  'admin.qwenKeys.resumed': '已恢复',
  'admin.qwenKeys.colWorkspace': '工作空间',
  'admin.qwenKeys.colRegion': '地区',
  'admin.qwenKeys.regionSg': '新加坡',
  'admin.qwenKeys.regionCn': '北京',
  'admin.qwenKeys.colWorkspaceId': '阿里云 ID',
  'admin.qwenKeys.colStatus': '状态',
  'admin.qwenKeys.colKeys': '密钥',
  'admin.qwenKeys.keyCounts': '共 {keys} 个，占用 {held}，空闲 {free}',
  'admin.qwenKeys.colLogRead': '日志读取',
  'admin.qwenKeys.logFailing': '读取失败',
  'admin.qwenKeys.colKey': '密钥',
  'admin.qwenKeys.colState': '状态',
  'admin.qwenKeys.colHolder': '占用者',
  'admin.qwenKeys.colLastIssued': '上次签发',
  'admin.qwenKeys.colToday': '今日（UTC+8）',
  'admin.qwenKeys.colAlarms': '告警',
  'admin.qwenKeys.colAccount': '账号',
  'admin.qwenKeys.colUnreported': '未上报',
  'admin.qwenKeys.colMismatched': '不匹配',
  'admin.qwenKeys.colIgnored': '上报被忽略',
  'admin.qwenKeys.stateActive': '启用',
  'admin.qwenKeys.statePaused': '已暂停',
  'admin.qwenKeys.stateHeld': '占用中',
  'admin.qwenKeys.stateFree': '空闲',
  'admin.qwenKeys.pausedByHand': '手动暂停',
  'admin.qwenKeys.pausedRefused': '阿里云拒绝了该密钥内容',
  'admin.qwenKeys.pausedWorkspace': '业务空间已暂停',
  'admin.qwenKeys.todaySessions': '{n} 个会话',
  'admin.qwenKeys.tokensIssued': '已签发 {n} 个 token',
  'admin.qwenKeys.speaks': '语音',
  'admin.qwenKeys.alarmUnclaimed': '无主',
  'admin.qwenKeys.alarmMismatch': '不匹配',
  'admin.qwenKeys.alarmConflict': '账号冲突',
  'admin.qwenKeys.confirmPauseTitle': '确认暂停？',
  'admin.qwenKeys.confirmPauseWorkspace': '恢复之前，不会再从该工作空间为新会话分配密钥。',
  'admin.qwenKeys.confirmPauseKey': '恢复之前，不会再把该密钥分配给新会话。',
  'admin.qwenKeys.fieldWorkspaceId': '阿里云工作空间 ID',
  'admin.qwenKeys.fieldWorkspace': '工作空间',
  'admin.qwenKeys.fieldRegion': '地区',
  'admin.qwenKeys.regionHint': '该工作空间所在的阿里云站点，添加后不能更改。',
  'admin.qwenKeys.chooseRegion': '选择地区',
  'admin.qwenKeys.fieldApikeyId': '密钥 ID（阿里云 apikey id）',
  'admin.qwenKeys.fieldLabel': '标签',
  'admin.qwenKeys.fieldSecret': '密钥内容',
  'admin.qwenKeys.fieldNote': '备注（可选）',
  'admin.qwenKeys.secretHint': '会向阿里云验证，加密保存，之后不再显示。',
  'admin.qwenKeys.workspaceAdded': '已添加工作空间',
  'admin.qwenKeys.keyAdded': '已添加密钥',
  'admin.qwenKeys.secretReplaced': '已替换密钥内容',
  'admin.qwenKeys.labelUpdated': '已更新标签',
  'admin.qwenKeys.errWorkspaceNotFound': '阿里云中没有这个工作空间，或无法列出。',
  'admin.qwenKeys.errWorkspaceUnreadable': '找到了工作空间，但无法读取它的模型日志。',
  'admin.qwenKeys.errSecretRefused': '阿里云不接受该密钥内容。',
  'admin.qwenKeys.historyTitle': '密钥历史',
  'admin.qwenKeys.windows': '占用窗口',
  'admin.qwenKeys.noWindows': '暂无占用窗口。',
  'admin.qwenKeys.noSessions': '没有会话记录。',
  'admin.qwenKeys.until': '至',
  'admin.qwenKeys.loadMore': '加载更多',
  'admin.qwenKeys.unclaimed': '无主记录',
  'admin.qwenKeys.events': '事件',
  'admin.qwenKeys.reportIgnored': '上报被忽略',
  'admin.qwenKeys.lease': '租约',
  'admin.qwenKeys.usageTokens': '输入 音频 {audioIn} + 文本 {textIn}，输出 文本 {textOut} + 音频 {audioOut} token',
  'admin.qwenKeys.noUsage': '无用量',
  'admin.qwenKeys.noRateYet': '（尚无汇率）',
  'admin.qwenKeys.colTenant': '租户 ID',
  'admin.qwenKeys.logLag': '滞后 {s} 秒',
  'admin.qwenKeys.neverRead': '从未读取',
  'admin.qwenKeys.watermark': '水位',
  'admin.qwenKeys.leaseLink': '租约，见“会话”页',
  // Local models (/docs/local-models)
  'localModels.title': '本地模型与许可证',
  'localModels.intro': 'Sokuji 在免费模式下可以下载的所有模型：用途、大小、来源，以及模型权重的许可证。',
  'localModels.runtimeTitle': '模型在哪里运行',
  'localModels.runtimeBody': '模型在浏览器中运行：通过 WebAssembly（WASM）用 CPU 运行，或通过 WebGPU 用 GPU 运行。WebGPU 模型需要支持 WebGPU 的浏览器和显卡。除此之外，模型运行得多快取决于你的设备。大小指下载大小，与 Sokuji 模型列表中显示的数字相同；加载模型至少需要同样多的内存。',
  'localModels.variantsNote': '如果一个模型有多个版本，Sokuji 会选择你的设备支持的版本。名称中带 f16 的版本需要支持 16 位着色器的 GPU。',
  'localModels.licenseTitle': '许可证',
  'localModels.licenseBody': 'Sokuji 本身免费且开源，采用 AGPL-3.0 许可证。模型不属于 Sokuji：每个模型都由其发布者按各自的许可证提供，列在下方。有些只允许非商业使用，少数没有声明任何许可证。使用某个模型，就需要遵守其发布者的条款。',
  'localModels.tier.open.label': '开放许可',
  'localModels.tier.open.desc': '宽松或仅要求署名的许可证：MIT、Apache-2.0、BSD、CC0、CC BY 或 CC BY-SA。',
  'localModels.tier.conditional.label': '附带条件',
  'localModels.tier.conditional.desc': '可以使用，但除署名外还有其他条款，例如地区限制、使用政策或 copyleft。具体见备注。',
  'localModels.tier.non-commercial.label': '仅限非商业',
  'localModels.tier.non-commercial.desc': '发布者只允许非商业使用，或只允许按其自身条款进行商业使用。',
  'localModels.tier.unstated.label': '未声明许可证',
  'localModels.tier.unstated.desc': '发布者没有授予任何许可。',
  'localModels.tier.cloud.label': '在线服务',
  'localModels.tier.cloud.desc': '不需要下载：文本会发送到在线服务，因此需要联网。',
  'localModels.flag.non-commercial-base': '非商业底模声音',
  'localModels.flag.removed-upstream': '已被发布者撤下',
  'localModels.flag.game-character': '游戏角色声音',
  'localModels.flagNcBase': '非商业底模声音：该声音基于 Piper 的 lessac 或 ryan 声音微调，而这两个声音的训练数据仅许可非商业使用。该声音自身的许可证没有说明这些条款是否随之适用。',
  'localModels.type.asr': '语音识别',
  'localModels.type.asr-stream': '流式语音识别',
  'localModels.type.translation': '翻译',
  'localModels.type.tts': '语音合成',
  'localModels.type.punctuation': '标点',
  'localModels.runtime.wasm': 'CPU（WASM）',
  'localModels.runtime.webgpu': 'WebGPU',
  'localModels.runtime.cloud': '在线',
  'localModels.col.model': '模型',
  'localModels.col.languages': '语言',
  'localModels.col.runtime': '运行于',
  'localModels.col.size': '大小',
  'localModels.col.source': '来源',
  'localModels.col.license': '许可证',
  'localModels.col.notes': '备注',
  'localModels.multilingual': '多语言',
  'localModels.package': '模型包',
  'localModels.filterLabel': '许可证',
  'localModels.search': '按名称、语言或许可证筛选',
  'localModels.showing': '显示 {count} 个模型',
  'localModels.noMatch': '没有符合筛选条件的模型。',
  'localModels.bundled': '每个离线语音识别模型包都包含：',
  'localModels.generatedFrom': '根据 Sokuji {version} 生成。',

  // Account deletion page
  'deleteAccount.title': '删除你的 Sokuji 账户',
  'deleteAccount.intro': 'Sokuji 由 Kizuna AI 开发。你在所有平台（包括 Android 和 iOS 应用）上都使用 Kizuna AI 账户登录 Sokuji。本页说明如何删除该账户，以及你的数据会如何处理。账户删除后无法恢复。',
  'deleteAccount.app.title': '在 Sokuji 移动应用中',
  'deleteAccount.app.items': '打开主界面的菜单|点按“账户”|点按“删除账户”并确认',
  'deleteAccount.web.title': '在网站上',
  'deleteAccount.web.items': '登录 sokuji.kizuna.ai|打开控制台，进入“安全设置”|选择“删除我的账户”，输入 DELETE 确认',
  'deleteAccount.email.title': '如果无法登录',
  'deleteAccount.email.content': '请用账户绑定的邮箱发送邮件至 privacy@kizuna.ai，要求删除账户。',
  'deleteAccount.deleted.title': '哪些内容会被删除',
  'deleteAccount.deleted.items': '你的账户，包括邮箱地址、显示名称、密码和登录记录|你的剩余余额，删除后无法恢复|你创建的自定义声音',
  'deleteAccount.partial.title': '不删除账户，只删除部分数据',
  'deleteAccount.partial.items': '保存在设备上的转写记录：在应用中打开“历史”后删除|使用分析数据：发送邮件至 privacy@kizuna.ai 要求删除',
};

export default zh;
